import React, {useEffect, useReducer, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import {
    addCard,
    cancelSubscriptionApi,
    createCharge,
    createChargeByAuthenticatedCard,
    createStripeCustomer,
    createSubscription,
    deleteBackground,
    getCard,
    getCreditsListApi,
    getUserChargesBill,
    getUserInvoices,
    getUserStripePrices,
    setBackground,
    updatePackCredit,
    updateShowActiveLogo,
    updateStripeCard,
    updateSubscriptionApi,
    updateThresholdCredit,
    updateUserCredit,
    uploadBackground,
    userAccountService,
    userDeleteAccount,
    userGetCurrencyService,
    userProfileUpdate,
    getInvoiceHistory
} from "../../services/userService";

import {couponsListService, updateUserCoupon,getCouponById} from "../../services/couponService"
import {
    AddIcon,
    CheckIcon,
    CloseEyeIcon,
    CloseIcon,
    DeleteIcon,
    EyeIcon,
    NoData,
    UplpadFileIcon
} from '../../assets/svg';
import {CountryDropdown, RegionDropdown} from 'react-country-region-selector';
import {Form, Tab, Tabs} from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import {MDBInput} from 'mdbreact';
import _ from 'lodash';
import Resizer from "react-image-file-resizer";
import CommonModal from '../common/commonModal';
import ContentModal from '../common/contentModal';
import {validateEmail, validateName, validatePassword,} from '../common/validation';
import InlineError from '../common/inlineError';
import { getDisplayMessage } from '../../helper';
import StripeScriptLoader from 'react-stripe-script-loader';
// import {asas} from '../../assets/img/images/American.jpg';
import Modal from 'react-bootstrap/Modal'

import moment from 'moment';
import {
    CardCVCElement,
    CardExpiryElement,
    CardNumberElement,
    Elements,
    injectStripe,
    StripeProvider,
} from 'react-stripe-elements';
import {addressListService,} from "../../services/addressService";
import visaIcon  from '../../assets/img/images/visa.png';

const UserDetail = (props) => {


    const [userInput, setUserInput] = useState({
        myFormRef: '',

        userCompanyName: '',
        companyNameError: '',
        streetAddress: '',
        vatPercent: 0,
        countryError: '',
        streetAddressError: '',
        suitUnit: '',
        suitUnitError: '',
        stateProvince: '',
        stateProvinceError: '',
        country: 'Denmark',
        city: '',
        cityError: '',
        vatNumber: '',
        vatNumberError: '',
        postalCode: '',
        postalCodeError: '',

        ToastMessage: '',
        ToastMessageSuccess: '',

        companyBox: false,

        additionalEmailError: '',
        fullNameError: '',
        emailError: '',

        userCompanyName1: '',
        streetAddress1: '',
        vatPercent1: '',
        suitUnit1: '',
        additionalEmail1: '',
        additionalEmail: '',
        currency: '',
        currencyError: '',
        currency1: '',
        country1: '',
        city1: '',
        vatNumber1: '',
        postalCode1: '',
        stateProvince1: '',
        taxStatus: '',


    });
    const [modalBg, setModalBg] = useState([]);
    // const [page, setPage] = useState(1);
    // const [limit, setLimit] = useState(10);
    // const [search, setSearch] = useState('');
    const [filterBy, setFilterBy] = useState('');
    const [pagination, setPagination] = useState('');
    const [list, setList] = useState([]);
    const [updateSubscriptionId, setUpdateSubscriptionId] = useState([]);
    //bg
    const [displayBg, setDisplayBg] = useState([]);
    const [displayLogo, setDisplayLogo] = useState([]);
    const [displayBanner, setDisplayBanner] = useState([]);
    const [displayNumberPlate, setDisplayNumberPlate] = useState([]);
    const [showBgImage, setShowBgImage] = useState();
    const [showBannerImage, setShowBannerImage] = useState();
    const [showBgValue, setShowBgValue] = useState({
        inputValue: '',
    });
    const [showBannerValue, setShowBannerValue] = useState({
        inputValue: '',
    });
    const [uploadedBackground, setUploadedBackground] = useState(''); //one
    const [uploadedLogo, setUploadedLogo] = useState('');
    const [uploadedBanner, setUploadedBanner] = useState('');
    const [uploadedNumberPlate, setUploadedNumberPlate] = useState('');
    const [activeBG, setActiveBG] = useState({
        activeValue: '',
    });
    const [activeLogo, setActiveLogo] = useState({
        activeValueLogo: '',
    });
    const [activeBanner, setActiveBanner] = useState({
        activeValueBanner: '',
    });
    const [activeNumberPlate, setActiveNumberPlate] = useState({
        activeValueNumberPlate: '',
    });
    const [modalBanner, setModalBanner] = useState([]);


//general
    const [show, setShow] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
            defaultTab: 1,
            defaultInvoiceTab: 1,
            defaultCreditTab: 1,
            emailBox: false,
            userEmail: '',
            newEmail: '',
            confrimEmail: '',
            newEmailError: '',
            confrimEmailError: '',

            userNameError: '',
            userNameBox: false,
            userName: '',

            passwordBox: false,
            confirmPassword: '',
            optifoPasswod: '',
            oldPassword: '',
            newPassword: '',
            oldPasswordError: '',
            confirmPasswordError: '',
            newPasswordError: '',
            optifoPasswodError: '',
            password: '',
            showPassword: true,
            showPassword1: true,
            showPassword2: true,

            companyNameBox: false,
            companyName: '',
            companyNameError: '',


            uploadBg: '',
            uploadLogo: '',
            uploadBanner: '',
            uploadNumberPlate: '',
            bgNLogo: false,
            bannerNPlate: false,
            bgUploadSizeError: false,
            bgImageExtError: false,
            logoUploadSizeError: false,
            logoImageExtError: false,
            bannerUploadSizeError: false,
            bannerImageExtError: false,
            numberPlateUploadSizeError: false,
            numberPlateImageExtError: false,

            ToastMessage: '',
            ToastMessageSuccess: '',

            errorMessage: '',
            loader: false,
            loadData: false,
            stripeCustomerId: '',
            totalPackCredits: '',
            planCheck: '',
            updateStateId: '',
            amountPay: '',
            creditAmount: '',
            subAmount: '',
            tax: '',
            carCount: 0,
            updatePlan: '',
            activePlanId: '',
            activePackId: '',
            totalCredits: '',
            usableCredits: '',
            leftCredits: '',
            modalCredit: false,
            creditError: '',
            credit: '',
            percentOff: '',
            promoError: '',
            promoBox: false,
            promo: '',
            couponList: [],


            currencyBox: false,
            codeMessageInvalid: '',
            codeMessage: '',
            packCheck: '',
            companyCancelBox: false,
            companyBox: false,
            brandImage: '',
            modalBgDefault: false,
            modalLogoDefault: false,
            modalBannerDefault: false,
            modalNumberPlateDefault: false,
            modalChangePlan: false,
            modalCancelPlan: false,
            modalSubscribePlan: false,
            modalCreditPack: false,
            modalBilling: false,
            leftPackCredits: '',
            viewMorePlans: false,
            additionalEmail1: '',
            showWhiteBg: false,
            modalBgDelete: false,
            cantDeleteBg: false,
            cantDeleteLogo: false,
            modalLogoDelete: false,
            cantDeleteBanner: false,
            modalBannerDelete: false,
            cantDeleteNumberPlate: false,
            modalNumberPlateDelete: false,
            deleteBgImageId: '',
            deleteLogoImageId: '',
            deleteBannerImageId: '',
            deleteNumberPlateImageId: '',
            showCustomBg: true,
            vatPercent: '',
            additionalEmail: '',

            currency: '',
            currency1: '',
            country: '',
            streetAddress: '',
            suitUnit: '',
            stateProvince: '',

            city: '',
            postalCode: '',
            vatNumber: '',

            streetAddressError: '',
            cityError: '',
            vatNumberError: '',
            postalCodeError: '',


            activePlan: false,
            updatePack: false,
            creditNumber: '',
            expiryDate: '',
            cvv: '',
            creditNumberBilling: '',
            expiryDateBilling: '',
            securityCode: '',
            stripeCardId: '',
            cardError: '',


            activeCreditPack: '',
            adminPromo: true,
            modalFillBilling: false,


            languageDansk: '',
            languageDeutsche: '',
            languageEnglish: '',
            languagePусс: '',
            getLangaugeType: '',

            planCredit: 0,


        }
    );
    //plan
    const [cardDetails, setCardDetails] = useState();
    const [planList, setPlanList] = useState([]);
    const [creditList, setCreditList] = useState([]);
    const [seeListItem, setSeeListItem] = useState(5);
    const [singlePlan, setSinglePlan] = useState([]);
    const [singlePack, setSinglePack] = useState([]);
    const [billingList, setBillingList] = useState([]);
    const [chargesList, setChargesList] = useState([]);

    const [cancelLoader, setCancelLoader] = useState(false);
    const [updatedSubscription, setUpdatedSubscription] = useState();


    const ref = useRef();
    const [notification, setNotification] = useState(true);

    const showNotification = () => setNotification(!notification);
    const [popup, setPopup] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
            cancelSubscriptionPopup: false,
            deleteAccountPopup: false,
        }
    );
    //plan declaration end

    //general start
    const UpdateCompanyName = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setShow({loadData: true});
            let {
                currency,
                userCompanyName1,
                additionalEmail,
                userCompanyName,
                streetAddress,
                vatPercent,
                suitUnit,
                stateProvince,
                city,
                postalCode,
                vatNumber,
                country,
            } = userInput;
            console.log("sasas>>>", userCompanyName,
                streetAddress,
                suitUnit,
                stateProvince,
                city,
                postalCode,
                vatNumber,
                country,)
            let obj = {
                usrId: props.match.params.id,
                additionalEmail: additionalEmail,
                vatPercent:vatPercent,
                companyDetails: {
                    companyName: userCompanyName ? userCompanyName : userCompanyName1,
                    currency: currency,
                    city: singleAddress.showCity == 1 ? city : '',
                    country,
                    state: singleAddress.showState == 1 ? stateProvince : '',
                    streetAddress: streetAddress,
                    suit: suitUnit,
                    postalCode: singleAddress.showPostal == 1 ? postalCode : '',
                    VatNo: singleAddress.showVat == 1 ? vatNumber : '',
                },
            };

            let accessToken = sessionStorage.getItem('accessToken');
            userProfileUpdate(obj, accessToken).then((res) => {
                setShow({loadData: false});
                if (res.status == 1) {
                    // setShow({ToastMessageSuccess: res.data.message});
                    setNotification(true);
                    setShow({loadData: false, companyNameBox: !show.companyNameBox});

                    setShow({
                        companyNameBox: false,

                        companyCancelBox: false
                    });
                    getMyUser();
                }
            });
        }
    };
    const handelChange = (e) => {

        console.log(e.target.name, e.target.value, "sssssasa>>>>>>")
        setShow({
            ...show,
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: '',
        });
    };
    const handelCreditChange = (e) => {

        console.log(e.target.name, e.target.value, "sssssasa>>>>>>")
        setShow({
            credit: e.target.value,

        });
    };
    const handleOnChangeNum = (e) => {
        if (e.target.value.length < 11) {
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
    };
    const ShowCompanyName = () => {
        setShow({
            ...show,
            companyNameBox: !show.companyNameBox,
            companyCancelBox: !show.companyCancelBox,
            emailBox: false,
            userNameBox: false,
            passwordBox: false,
        });
        setUserInput({
            ...userInput,
            userCompanyName: userInput.userCompanyName1,
            streetAddress: userInput.streetAddress1,
            userCompanyName1: userInput.userCompanyName1 ? userInput.userCompanyName1 : userInput.userCompanyName,
            currency: userInput.currency1,
            suitUnit: userInput.suitUnit1 ? userInput.suitUnit1 : '',
            stateProvince: userInput.stateProvince1 ? userInput.stateProvince1 : '',
            city: userInput.city1 ? userInput.city1 : '',
            country: userInput.country1,
            postalCode: userInput.postalCode1 ? userInput.postalCode1 : '',
            vatNumber: userInput.vatNumber1,
            additionalEmail: userInput.additionalEmail1 ? userInput.additionalEmail1 : show.additionalEmail,
            additionalEmail1: userInput.additionalEmail1 ? userInput.additionalEmail1 : show.additionalEmail,

        });
    };
    const ShowCompany = () => {
        console.log(show, show.companyBox, "ASdddddsds", userInput.userCompanyName1)
        setShow({
            ...show,
            companyNameError: '',
            // companyNameBox: !show.companyNameBox,
            companyBox: show.companyBox ? '' : userInput.userCompanyName1,
            // companyCancelBox: !show.companyCancelBox,
            emailBox: false,
            userNameBox: false,
            passwordBox: false,
        });
        setUserInput({
            ...userInput,
            userCompanyName: userInput.userCompanyName1,
            userCompanyName1: userInput.userCompanyName1,
            currency: userInput.currency1,
            streetAddress: userInput.streetAddress1,
            vatPercent: userInput.vatPercent1,
            suitUnit: userInput.suitUnit1,
            stateProvince: userInput.stateProvince1,
            city: userInput.city1,
            country: userInput.country1,
            postalCode: userInput.postalCode1,
            vatNumber: userInput.vatNumber1,
            additionalEmail: userInput.additionalEmail1
        });
    };
    const closeCompany = () => {
        console.log(show, show.companyBox, "ASdddddsds", userInput.userCompanyName1)
        setShow({
            companyBox: '',
            companyNameError: '',
            emailBox: false,
            userNameBox: false,
            passwordBox: false,
        });
        setUserInput({
            companyNameError: '',
            companyBox: '',
        });
    };
    const UpdateName = (e) => {
        e.preventDefault();

        if (show.userName === ' ') {
            setShow({userNameError: "Enter full name"});
        } else if (!validateName(show.userName).status) {
            setShow({userNameError: "Enter valid full name"});
        } else {
            console.log(props.match, ";lkjhjkkjs")
            let obj = {
                usrId: props.match.params.id,
                fullName: show.userName,
            };
            setShow({loadData: true});
            let accessToken = sessionStorage.getItem('accessToken');
            userProfileUpdate(obj, accessToken).then((res) => {
                setShow({loadData: false});
                if (res.status == 1) {
                    setShow({
                        // ToastMessageSuccess: res.data.responseData.message,
                        userNameBox: !show.userNameBox,
                    });

                    getCompanyInfo();
                }
            });
        }
    };
    const UpdateNames = () => {

            console.log(props.match, ";lkjhjkkjs")
            let obj = {
                usrId: props.match.params.id,
                fullName: show.userName,
            };
            // setShow({loadData: true});
            let accessToken = sessionStorage.getItem('accessToken');
            userProfileUpdate(obj, accessToken).then((res) => {
                setShow({loadData: false});
                if (res.status == 1) {
                    setShow({
                        // ToastMessageSuccess: res.data.responseData.message,
                        userNameBox: !show.userNameBox,
                    });

                    getCompanyInfo();
                }
            });

    };
    const handleOnChangeNum1 = (e) => {
        if (e.target.value.length < 9) {
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
    };

    function handlePasswordValidation() {
        let validate = true;

        if (show.oldPassword === '') {
            validate = false;
            setShow({oldPasswordError: `${('Please enter old password')}`});
        } else if (!validatePassword(show.oldPassword.trim()).status) {
            validate = false;
            setShow({oldPasswordError: 'Please enter valid old password.'});
        }

        if (show.newPassword.trim() === '') {
            validate = false;
            setShow({newPasswordError: `${('Please enter new password')}`});
        } else if (!validatePassword(show.newPassword.trim()).status) {
            validate = false;
            setShow({newPasswordError: `${('Please enter valid new password.')}`});
        }

        if (show.confirmPassword.trim() === '') {
            validate = false;
            setShow({confirmPasswordError: `${('Please enter confirm password')}`});
        } else if (!validatePassword(show.confirmPassword.trim()).status) {
            validate = false;
            setShow({confirmPasswordError: `${('Please enter valid confirm password')}`});
        } else if (show.confirmPassword.trim() !== show.newPassword.trim()) {
            validate = false;
            setShow({confirmPasswordError: `${('New password and confirm password shold be same')}`});
        }

        return validate;
    }

    const UpdatePassword = (e) => {
        e.preventDefault();
        console.log(show.oldPassword, "axxxxxxxxxxxxxx")
        if (handlePasswordValidation()) {
            setShow({loadData: true});

            let obj = {
                usrId: props.match.params.id,
                optifoPassword: show.oldPassword,
                password: show.newPassword,
            };

            let accessToken = sessionStorage.getItem('accessToken');
            userProfileUpdate(obj, accessToken).then((res) => {
                console.log(res, "Saaaaaaaaaaaaaaaaaaaaaaaaaaa")
                setShow({loadData: false});

                if (res.status == 1) {
                    // setShow({ToastMessageSuccess: res.responseData.message});
                    setNotification(true);
                    setShow({
                        ...show,
                        passwordBox: false,
                        confirmPassword: '',
                        confirmPasswordError: '',
                        newPasswordError: '',
                        oldPasswordError: '',
                        newPassword: '',
                        oldPassword: '',
                    });
                    getCompanyInfo();
                    getMyUser();
                } else {
                    setShow({
                        oldPasswordError: res.data,
                    });
                }
            });
        }
    }


    const getCompanyInfo = () => {
        let userId = props.match.params.id;
        let params = `?userId=${userId}`;

        userAccountService(params).then((res) => {
            // ResponseFilter(res);
            if (res.data.statusCode == 1) {
                console.log(res.data,"res.datares.data")
                let result = res.data.responseData.userProfile.companyDetails;
                let result1 = res.data.responseData.userProfile;

                setUserInput({

                    additionalEmail1: res.data.responseData.userProfile.additionalEmail,


                    currency1: result.currency,
                    email: res.data.responseData.userProfile.email,
                    vatPercent: res.data.responseData.userProfile.vatPercent,
                    userCompanyName1: result.companyName,
                    streetAddress1: result.streetAddress,
                    suitUnit1: result.suit,
                    country: result.country,
                    country1: result.country,
                    city1: result.city,
                    vatNumber1: result.VatNo,
                    postalCode1: result.postalCode,
                    stateProvince1: result.state,

                    additionalEmail: res.data.responseData.userProfile.additionalEmail,
                    currency: result.currency,
                    userCompanyName: result.companyName,
                    streetAddress: result.streetAddress,
                    suitUnit: result.suit,
                    city: result.city,
                    vatNumber: result.VatNo,
                    postalCode: result.postalCode,
                    stateProvince: result.state,
                    companyNameBox: result.currency && result.streetAddress ? false : true,
                    companyBox: result.companyName

                });

                setShow({
                    usrId: result1._id,
                    stripeCardId: result1.stripeCardId,
                    stripeCustomerId: result1.stripeCustomerId,
                    userName: result1.fullName,
                    additionalEmail: result1.additionalEmail,
                    currency: result.currency,
                    currency1: result.currency,
                    companyName: result.companyName,
                    additionalEmail1: result1.additionalEmail,
                    userEmail: result1.email,
                    email: result1.email,
                    userCompanyName1: result.companyName,
                    streetAddress1: result.streetAddress,
                    vatPercent1: result.vatPercent,
                    suitUnit1: result.suit,
                    country: result.country,
                    country1: result.country,
                    city1: result.city,
                    vatNumber1: result.VatNo,
                    postalCode1: result.postalCode,
                    stateProvince1: result.state,
                    userCompanyName: result.companyName,
                    streetAddress: result.streetAddress,
                    suitUnit: result.suit,
                    city: result.city,
                    vatNumber: result.VatNo,
                    postalCode: result.postalCode,
                    stateProvince: result.state,


                });


            }
        });
    };


    const getPlansList = (curr) => {
        let accessToken = sessionStorage.getItem('accessToken');

        console.log(show, "sssssssssssssssssssssssssssBBB", userInput, "showshowshow")
        let params = `?usrId=${props.match.params.id}&limit=${10000}&currency=${curr}`;

        getUserStripePrices(params, accessToken).then((res) => {
            // console.log(res.data.responseData.activeSubscriptions);
            // getPlansList(res,"getPlansListvvgetPlansListgetPlansList");
            if (res.status == 1) {
                let plans = res.data.stripePrices;
                plans = plans.filter(data => data.transform_quantity !== null)
                console.log("#########################", plans)
                let listPlans = plans.sort((a, b) =>
                    a.unit_amount > b.unit_amount
                        ? 1
                        : b.unit_amount > a.unit_amount
                        ? -1
                        : 0
                );


                setPlanList(listPlans);
                setUpdateSubscriptionId(res.data.activeSubscriptions);


                if (res.status == 1) {
                    let addrData = listPlans;

                    console.log(addrData, ">>>>>>>>>>>>>>>>>>>ssassssssssssss>xxxxxxxxxxxxx",)

                    let a = [];
                    let ab = [];
                    addrData.forEach(function (obj) {
                        // a.push(obj.currency);
                        ab.push(obj.currency);
                    })
                    // setWhiteListedCountries(ab)

                    console.log(ab, "sddddddddddddddddddxxxxxxxxxxxxx")
                }

            } else {
                // sessionStorage.removeItem('accessToken');
                // hpr.push('/unlog');
            }
        });
    };
    const getCreditsList = (curr) => {
        let accessToken = sessionStorage.getItem('accessToken');

        console.log(show, "sssssssssssssssssssssssssssBBB", userInput, "showshowshow")
        // let params = `?usrId=${props.match.params.id}&currency=${"USD"}`;
        let params = `?usrId=${props.match.params.id}&limit=${10000}&currency=${curr}`;


        getCreditsListApi(params, accessToken).then((res) => {
            // console.log(res.data.responseData.activeSubscriptions);
            if (res.status == 1) {
                let creditList = res.data.result;
                console.log("#########################", creditList)


                setCreditList(creditList);
                // setUpdateSubscriptionId(res.data.responseData.activeSubscriptions);
            } else {
                // sessionStorage.removeItem('accessToken');
                // Router.push('/unlog');
            }
        });

    };


    // end bg
    const getMyUser = () => {

        userGetCurrencyService(``).then((response) => {
            console.log(response, "adddddddddd", show.codeMessageInvalid)
            if (response.status == 1) {
                let currencyData = response.data.result;
                console.log(currencyData, ">>>>>>>>>>>>>>>>>>ssassssssssssss>",)
                setCurrencyData(currencyData)
                let c = [];
                currencyData.forEach(function (obj) {
                    c.push(obj.currencyCode);
                })

                /* if (currency_name) {
                     let exist = c.includes(currency_name.toLowerCase()) // true
                     console.log(c,"cccccccccccccccccccccccccc",exist,currency_name)

                     if (exist) {
                         console.log("Sssssssssssssssssssx1",currency_name.toLowerCase())
                         currency_name.toLowerCase()
                     }else{
                         currency_name="usd"
                         console.log("Sssssssssssssssssssx2",currency_name.toLowerCase())

                     }
                 }*/
                // if (currency_name) {
                //     let exist = c.includes(currency_name.toLowerCase()) // true
                //     if (exist) {
                //         currency_name.toLowerCase()
                //     } else {
                //         currency_name = "usd"
                //
                //
                //     }
                // }
            }
        });


        console.log("kjlhukgyjfgh", props)
        let userId = props.match.params.id;

        console.log(userId, "Dddddddddddddddddddd")
        let params = `?userId=${userId}`;
        userAccountService(params)
            .then(res => {

                // userAccountService(params).then((res) => {
                // setLoader(false);
                if (res.status) {
                    console.log(res, "res.data", res.data.userProfile.companyDetails, "00datauserProfile.emailpropsprops")

                    if (res.data) {
                        setThresHoldStatus(res.data.userProfile.thresholdRefillStatus);
                        setShowActiveLogo(res.data.userProfile.showActiveLogo);
                        setShowCoupon(res.data.userProfile.showCoupon);

                        setShow({


                            ToastMessageSuccess: res.data.message,
                            stripeCardId: res.data.userProfile.stripeCardId,

                            stripeCustomerId: res.data.userProfile.stripeCustomerId,

                            additionalEmail: res.data.userProfile.additionalEmail,
                            additionalEmail1: res.data.userProfile.additionalEmail,
                            userEmail: res.data.userProfile.email ? res.data.userProfile.email : '',
                            password: res.data.userProfile.password,
                            companyName: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.companyName,
                            userName: res.data.userProfile.fullName,
                            currency: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.currency ? res.data.userProfile.companyDetails.currency : 'USD',
                            currency1: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.currency ? res.data.userProfile.companyDetails.currency : 'USD',
                            companyNameBox: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.currency && res.data.userProfile.companyDetails.streetAddress && res.data.userProfile.companyDetails.VatNo ? false : true,
                            totalCredits: res.data.userProfile.totalCredits,
                            usableCredits: res.data.userProfile.usableCredits,
                            leftCredits: res.data.userProfile.leftCredits,
                            totalPackCredits: res.data.userProfile.totalPackCredits,
                            leftPackCredits: res.data.userProfile.leftPackCredits,
                            stateProvince: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.state,
                            stateProvince1: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.state,
                            userCompanyName1: res.data.userProfile.companyDetails.companyName,

                            companyBox: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.companyName ? res.data.userProfile.companyDetails.companyName : false,
                            promo: res.data.userProfile.couponId ? res.data.userProfile.couponId : '',
                            activeCreditPack: res.data.userProfile.activeCreditPack ? res.data.userProfile.activeCreditPack : '',
                            adminPromo: res.data.userProfile.couponId ? false : true,
                            percentOff: res.data.userProfile.percentOff ? res.data.userProfile.percentOff : '',
                        });


                        console.log(res.data.userProfile.companyDetails, "res.data.userProfile.companyDetails>>>")

                        setUserInput({
                            ...userInput,
                            userCompanyName: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.companyName,
                            userCompanyName1: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.companyName,
                            currency: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.currency ? res.data.userProfile.companyDetails.currency : 'USD',
                            currency1: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.currency ? res.data.userProfile.companyDetails.currency : 'USD',
                            suitUnit: res.data.userProfile.companyDetails.suit ? res.data.userProfile.companyDetails.suit : '',
                            suitUnit1: res.data.userProfile.companyDetails.suit ? res.data.userProfile.companyDetails.suit : '',
                            vatPercent: res.data.userProfile.vatPercent,
                            vatPercent1: res.data.userProfile.vatPercent,

                            streetAddress: res.data.userProfile.companyDetails.streetAddress ? res.data.userProfile.companyDetails.streetAddress : '',
                            streetAddress1: res.data.userProfile.companyDetails.streetAddress ? res.data.userProfile.companyDetails.streetAddress : '',

                            stateProvince: res.data.userProfile.companyDetails.state ? res.data.userProfile.companyDetails.state : '',
                            stateProvince1: res.data.userProfile.companyDetails.state ? res.data.userProfile.companyDetails.state : '',
                            city: res.data.userProfile.companyDetails.city ? res.data.userProfile.companyDetails.city : '',

                            city1: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.city,
                            country: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.country,
                            country1: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.country,
                            vatNumber: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.VatNo,
                            vatNumber1: res.data.userProfile.companyDetails && res.data.userProfile.companyDetails.VatNo,
                            additionalEmail: res.data.userProfile && res.data.userProfile.additionalEmail,
                            additionalEmail1: res.data.userProfile && res.data.userProfile.additionalEmail,
                            companyNameBox: res.data.userProfile.companyDetails.currency && res.data.userProfile.companyDetails.streetAddress ? false : true,
                            companyBox: res.data.userProfile.companyDetails.companyName,
                            suit: res.data.userProfile.companyDetails.suit ? res.data.userProfile.companyDetails.suit : '',
                            postalCode: res.data.userProfile.companyDetails.postalCode ? res.data.userProfile.companyDetails.postalCode : '',
                            postalCode1: res.data.userProfile.companyDetails.postalCode ? res.data.userProfile.companyDetails.postalCode : '',
                            VatNo: res.data.userProfile.companyDetails.vatNumber ? res.data.userProfile.companyDetails.vatNumber : '',
                            VatNo1: res.data.userProfile.companyDetails.vatNumber ? res.data.userProfile.companyDetails.vatNumber : '',
                            taxStatus: res.data.userProfile.taxStatus,

                        });
                        console.log(res.data.userProfile, "SdddddCX<Vxcv")

                        let curr = res.data.userProfile.companyDetails.currency ? res.data.userProfile.companyDetails.currency : 'USD'

                        getPlansList(curr ? curr : 'USD');
                        getCreditsList(curr ? curr : 'USD');

                        // getPlansList();
                        // getCreditsList();
                        if (res.data.userProfile.stripeCardId) {
                            // getMyCards();
                            console.log(res.data.userProfile, "######################33")

                            getMyCards(
                                res.data.userProfile.stripeCardId,
                                res.data.userProfile.stripeCustomerId
                            );
                        }
                        // getCompanyInfo();


                        addressListService(``).then((response) => {
                            console.log(response, "adddddddddd", show.codeMessageInvalid)

                            if (response.status == 1) {
                                let addrData = response.data.result;

                                console.log(addrData, ">>>>>>>>>>>>>>>>>>>>")
                                let a = [];
                                let ab = [];
                                addrData.forEach(function (obj) {
                                    a.push(obj.country);
                                    ab.push(obj.countryCode);
                                })
                                setWhiteListedCountries(ab)
                                let val = res.data.userProfile.companyDetails.country ? res.data.userProfile.companyDetails.country : "USD"

                                if (val) {

                                    let exist = a.includes(val); // true

                                    if (!exist) {
                                        setUserInput(prevState => ({
                                            ...prevState,
                                            country: "United States",
                                            country1: "United States"
                                        }));
                                        setSingleAddress({
                                            postalName: "ZIP",
                                            showPostal: 1,
                                            cityName: "City",
                                            showCity: 1,
                                            stateName: "State",
                                            showState: 1,
                                        })

                                    }

                                    if (exist) {
                                        console.log(a, "ssssssssssssssssssdddddddddddddd", exist)
                                        addrData && addrData.map((item, i) => {
                                            if (item.country == val) {

                                                setSingleAddress(item)

                                            }
                                        })
                                    }        // setShow({couponList: })


                                }
                            }
                        });
                    } else {
                        // setShow({ToastMessage: res.data.error.responseMessage});
                        // setNotification(true);
                    }
                }
            });
    }

    const getTabValue = (e) => {

        console.log("saaaaaaaaaaasaszx", e)
        setShow({
            ...show,
            defaultTab: e,
            bgNLogo: true,
            bannerNPlate: true,
            showWhiteBg: false,
            showCustomBg: false,
        });
    };

    const handleOnChange = (e, type) => {
        if (type == 'currency' && e.target.value.length < 50) {
            console.log(e.target.value, "e.target.value.length")
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
        if (type == 'fullName' && e.target.value.length < 50) {
            setShow({
                ...show,
                userName:e.target.value,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }

        if (type == 'userCompanyName' && e.target.value.length < 50) {
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
        if (type == 'streetAddress' && e.target.value.length < 150) {
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
        if (type == 'suitUnit' && e.target.value.length < 30) {
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
        if (type == 'city' && e.target.value.length < 30) {
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
        if (type == 'city' && e.target.value.length < 30) {
            setUserInput({
                ...userInput,
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: '',
            });
        }
    };
    const countrySelect = (val) => {
        setUserInput({
            ...userInput,
            country: val,
        });
        // addressListService(params).then(res => {
        let params = ``;

        addressListService(params).then((response) => {
            console.log(response, "adddddddddd", show.codeMessageInvalid)

            if (response.status == 1) {
                let addrData = response.data.result;

                console.log(addrData, ">>>>>>>>>>>>>>>>>>>>", val)
                let a = [];
                addrData.forEach(function (obj) {
                    a.push(obj.country);
                })

                let exist = a.includes(val); // true

                if (!exist) {
                    // {singleAddress.showPostal } {singleAddress.showCity }{singleAddress.showState }
                    setSingleAddress({
                        postalName: "Postal/ZIP",
                        showPostal: 1,
                        cityName: "City",
                        showCity: 1,
                        stateName: "State/Province",
                        showState: 1,
                    })

                } else {
                    console.log(a, "ssssssssssssssssssdddddddddddddd", exist)
                    addrData && addrData.map((item, i) => {


                        if (item.country == val) {
                            setSingleAddress(item)
                            setUserInput({
                                ...userInput,
                                vatPercent: item.vatPercent,
                                country: val,
                            });
                            console.log(item.country, val, item, ">>>>>>>>>>>>>>>>>>>>jhgsssssssssssss")
                        }
                    })
                }        // setShow({couponList: })


            }
        });


    };

    const stateSelect = (val) => {
        setUserInput({
            ...userInput,
            stateProvince: val,
        });
    };
    const [whiteListedCountries, setWhiteListedCountries] = useState([]);
    const [singleAddress, setSingleAddress] = useState([]);
    const [thresHoldStatus, setThresHoldStatus] = useState(1);
    const [showActiveLogo, setShowActiveLogo] = useState(1);
    const [showCoupon, setShowCoupon] = useState(1);
    const [currencyData, setCurrencyData] = useState([]);

    const ShowEmailBox = () => {
        setShow({
            ...show,
            emailBox: !show.emailBox,
            passwordBox: false,
            userNameBox: false,
            companyNameBox: false,
            newEmail: '',
            confrimEmail: '',
            optifoPasswod: '',
            confrimEmailError: '', newEmailError: '', optifoPasswodError: ''
        });
    };
    const ShowUserNameBox = () => {
        setShow({
            userNameBox: !show.userNameBox,
            passwordBox: false,
            emailBox: false,
            companyBox: false,
            companyNameBox: false,
            userName: '',
        });
        getMyUser();
    };
    const ShowPasswordBox = () => {
        setShow({
            ...show,
            passwordBox: !show.passwordBox,
            emailBox: false,
            userNameBox: false,
            companyNameBox: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            confirmPasswordError: '',
            newPasswordError: '',
            oldPasswordError: '',
        });
    };

    const UpdateEmail = (e) => {
        e.preventDefault();
        // if (handleEmailValidation()) {
        //     setShow({loadData: true});
        //     let obj = {
        //         email: show.newEmail,
        //         optifoPassword: show.optifoPasswod,
        //     };
        //
        //     let accessToken = sessionStorage.getItem('accessToken');
        //     carService.userProfileUpdate(obj, accessToken).then((res) => {
        //         sessionStorage.setItem(
        //             'accessToken',
        //             res.data.responseData ? res.data.responseData.newToken : ''
        //         );
        //         // ResponseFilter(res);
        //         setShow({loadData: false});
        //         if (res.data.statusCode == 1) {
        //             setShow({ToastMessageSuccess: res.data.responseData.message});
        //             sessionStorage.setItem('accessToken', res.data.responseData.newToken);
        //
        //             setNotification(true);
        //             setShow({...show, emailBox: false});
        //             getMyUser();
        //         } else {
        //             setShow({
        //                 optifoPasswodError: res.data.error.responseMessage,
        //             });
        //         }
        //     });
        // }
    };
    const deleteAccount = () => {
        // setCancelLoader(true);
        let accessToken = sessionStorage.getItem('accessToken');
        let params = `?userId=${props.match.params.id}`
        userDeleteAccount(params, accessToken).then((res) => {
            // ResponseFilter(res);
            CloseCancelSubscriptionPopup();
            setCancelLoader(false);
            if (res.status == 1) {
                // sessionStorage.removeItem('accessToken');
                props.history.push('/users');
            }
        });
    };
    useEffect(() => {
        console.log("zxcccccccccccccc")
        // getPlansList();
        getMyUser();
        // getCreditsList();

        getMyBills();
    }, [])
    const updateTabs = (props) => {

        console.log()
        let activeValue = 1
        let logoActiveTab = false
        let billActiveTab = "";
        console.log(props, "activeValueactiveValueactiveValue")

        if (activeValue == 2) {
            setShow({
                defaultTab: 2,
                bgNLogo: true,
                showWhiteBg: false,
                showCustomBg: false,
            });
            document.body.classList.remove('overflow-hidden');
        }
        if (logoActiveTab === 'true') {
            setShow({
                ...show,
                showWhiteBg: true,
                showCustomBg: true,
                defaultTab: 2,
            });
        }
        if (billActiveTab == 'active') {
            setShow({...show, defaultTab: 3});
        }
    };

    useEffect(async () => {
        await updateTabs(props);
        // const abc = localStorage.getItem('i18nextLng');
        // const getSubstring = abc.substring(0, 2);
        // if (getSubstring == 'en') {
        //     setSelectedLangage(getSubstring);
        // } else {
        //     setSelectedLangage(
        //         localStorage.getItem('i18nextLng')
        //             ? localStorage.getItem('i18nextLng')
        //             : ''
        //     );
        // }

        getBGImages();
    }, []);

    // const getList = () => {
    //     console.log("Sxxxxxxxxxxxxxxxxxxxasx")
    //     let params = `?page=${page}&limit=${10}&search=${''}`;
    //     userListService(params).then(res => {
    //         // setLoader(false);
    //         if (res.status) {
    //             setList(res.data.userList);
    //             setPagination({
    //                 currentPage: res.data.currentPage,
    //                 pageSize: res.data.pageSize,
    //                 totalPages: res.data.totalPages,
    //             })
    //         }
    //     })
    // }


    //bg section
    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                140,
                140,
                'PNG',
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                'file',
                140,
                140
            );
        });

    const OpenBgDeleteModal = (id, totalLength) => {
        setShow({modalBgDelete: true, deleteBgImageId: id});
        if (totalLength === 1) {
            setShow({cantDeleteBg: true});
        }
    };
    const CloseBgDeleteModal = () => {
        setShow({...show, modalBgDelete: false, cantDeleteBg: false});
    };
    const OpenLogoDeleteModal = (id, totalLength) => {
        setShow({modalLogoDelete: true, deleteLogoImageId: id});
        if (totalLength === 1) {
            setShow({cantDeleteLogo: true});
        }
    };
    const CloseLogoDeleteModal = () => {
        setShow({...show, modalLogoDelete: false, cantDeleteLogo: false});
    };
    const OpenLogoModal = () => {
        setShow({...show, modalLogoDefault: true});
    };
    const CloseLogoModal = () => {
        setShow({
            ...show,
            uploadBg: '',
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            logoUploadSizeError: false,
            logoImageExtError: false,
            uploadLogo: false,
            modalLogoDefault: false,
        });
    };
    const uploadBackgroundBody = (
        <div>
            <Tabs
                defaultActiveKey="gallery"
                className="breadcrumb-account"
                id="uncontrolled-tab-example"
            >
                <Tab eventKey="gallery" title="Gallery">
                    <div className="bg-modal-list">
                        <div className="row">
                            {modalBg.map((item, i) => {
                                return (
                                    <div className="col-md-3 mb-3" key={i}>
                                        <div className="custom-bg-main">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="showBgValue"
                                                    value={showBgValue.inputValue}
                                                    onChange={(e) =>
                                                        SelectBgImage(e, item.backgroundImage)
                                                    }
                                                />
                                                <span></span>
                                            </label>
                                            <div className="custom-bg-in">
                                                <img src={item.backgroundImage} className="w-100"/>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="text-right">
                        <button
                            className="btn btn-black"
                            disabled={!showBgImage ? true : false}
                            onClick={PostBgImage}
                        >
                            Ok
                        </button>
                    </div>
                </Tab>
                <Tab eventKey="upload" title="Upload">
                    <Dropzone
                        onDrop={(acceptedFile) => handleBackgroundImage(acceptedFile)}
                        maxSize={400000000}
                    >
                        {({getRootProps, getInputProps}) => (
                            <>
                                {show.uploadBg ? (
                                    <div>
                                        <img src={show.uploadBg} alt="" className="w-100"/>
                                        <div className="text-right mt-2">
                                            <button
                                                className="btn btn-white px-3 py-2"
                                                onClick={AgainBgUpload}
                                            >
                                                {"Change image"}
                                            </button>
                                            <button
                                                className="btn btn-black px-3 py-2 ml-2"
                                                onClick={BgUploadDone}
                                            >
                                                {"OK"}
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="upload_file_main">
                                        <div className="upload_file h-100" {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <div
                                                className="d-flex align-items-center justify-content-center h-100 text-center">
                                                <div>
                                                    <UplpadFileIcon/>
                                                    <p className="mt-2 mb-2">
                                                        'Drag and drop or'
                                                        <strong className="text-decoration-underline">
                                                            'upload from computer'
                                                        </strong>
                                                    </p>
                                                    <p className="small mb-2">
                                                        NOTE: Background size 1600 x 1200 pixels
                                                    </p>
                                                    <p className="small">
                                                        (Wall height 720 pixels + floor height 480 pixels)
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <small className="text-red">
                                        {show.bgUploadSizeError ? 'Please upload valid image size (1600px x 1200px).' : ''}
                                    </small>
                                </div>
                                <div>
                                    <small className="text-red">
                                        {show.bgImageExtError ? 'Only jpg, jpeg and png files are allowed.' : ''}
                                    </small>
                                </div>
                            </>
                        )}
                    </Dropzone>
                </Tab>
            </Tabs>
        </div>
    );
    const uploadLogoBody = (
        <Dropzone
            onDrop={(acceptedFile) => handleLogoImage(acceptedFile)}
            maxSize={400000000}
        >
            {({getRootProps, getInputProps}) => (
                <>
                    {show.uploadLogo ? (
                        <div>
                            <img src={show.uploadLogo} alt="" className="w-100"/>
                            <div className="text-right mt-2">
                                <button
                                    className="btn btn-white px-3 py-2"
                                    onClick={AgainLogoUpload}
                                >
                                    {'Change logo'}
                                </button>
                                <button
                                    className="btn btn-black px-3 py-2 ml-2"
                                    onClick={LogoUploadDone}
                                >
                                    {'OK'}
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="upload_file_main">
                            <div className="upload_file h-100" {...getRootProps()}>
                                <input {...getInputProps()} />
                                <div className="d-flex align-items-center justify-content-center h-100 text-center">
                                    <div>
                                        <UplpadFileIcon/>
                                        <p className="mt-2 mb-0">
                                            {'Drag and drop or'}
                                            <strong className="text-decoration-underline">
                                                {'upload from computer'}
                                            </strong>
                                        </p>
                                        <p className="small mb-2">NOTE: Recommended height 140</p>
                                        <div>
                                            <small className="text-red">
                                                {show.logoUploadSizeError
                                                    ? 'Minimum logo height should be 140px.'
                                                    : ''}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div>
                        <small className="text-red">
                            {show.logoImageExtError ? 'Only jpg, jpeg and png files are allowed.' : ''}
                        </small>
                    </div>
                </>
            )}
        </Dropzone>
    );


    const BgUploadDone = (e) => {
        var bg = new FormData();
        bg.append('bg', uploadedBackground);
        let obj = `?backgroundType=${'background'}&usrId=${props.match.params.id}`;
        let accessToken = sessionStorage.getItem('accessToken');
        uploadBackground(obj, bg, accessToken).then((res) => {
            console.log(res, "Sffffffsd");
            if (res.status === 1) {
                ActiveBg(e, res.data)

                getBGImages();
                setShow({loadData: true});
            }
            setShow({...show, modalBgDefault: false});
        });
    };

    const handleLogoImage = async (droppedFile) => {
        let reader = new FileReader();
        let img = new Image(droppedFile);
        let fileLogo = droppedFile[0];
        let logoIdxDot = fileLogo.name.lastIndexOf('.') + 1;
        let logoExtFile = fileLogo.name
            .substr(logoIdxDot, fileLogo.name.length)
            .toLowerCase();
        if (logoExtFile == 'jpg' || logoExtFile == 'jpeg' || logoExtFile == 'png') {
            const image = await resizeFile(fileLogo);
            const dimensions = await imageDimensions(fileLogo);

            if (dimensions.height > 141) {
                reader.addEventListener(
                    'load',
                    () => {
                        setShow({
                            ...show,
                            uploadLogo: reader.result,
                            challengeImageErrorMsg: '',
                            docErrorMsg: '',
                            logoUploadSizeError: false,
                            logoImageExtError: false,
                        });
                    },
                    false
                );
                if (image) {
                    reader.readAsDataURL(fileLogo);
                    setUploadedLogo(image);
                }
            } else {
                setShow({
                    ...show,
                    logoUploadSizeError: true,
                    uploadLogo: '',
                    challengeImageErrorMsg: '',
                    docErrorMsg: '',
                });
            }
        } else {
            setShow({
                ...show,
                uploadLogo: '',
                challengeImageErrorMsg: '',
                docErrorMsg: '',
                logoImageExtError: true,
            });
        }
    };
    const AgainLogoUpload = () => {
        setShow({
            ...show,
            uploadBg: '',
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            uploadLogo: false,
        });
    };

    function getBGImages() {
        let userId = props.match.params.id;
        let accessToken = sessionStorage.getItem('accessToken');
        let params = `?userId=${userId}`;
        // getUserProfileInfo(accessToken).then((res) => {
        //     userAccountService(params,accessToken).then((res) => {
        userAccountService(params).then((res) => {
            // ResponseFilter(res);
            if (res.status === 1) {
                console.log("********************###")
                setDisplayBg(res.data.userProfile.backgroundsUploaded || []);
                setDisplayLogo(res.data.userProfile.logosUploaded || []);
                setDisplayBanner(res.data.userProfile.bannersUploaded || []);
                setDisplayNumberPlate(res.data.userProfile.numberPlatesUploaded || []);
                setModalBg(res.data.userProfile.optifoBackgrounds || []);
                setModalBanner(res.data.userProfile.optifoBanners || []);
            }
        });
    }

    const addUploadFile = (
        <div className="account-card-list h-100">
            <div className="add-new-bg h-100">
                <div>
                    <AddIcon/>
                    <div className="bg-lable text-uppercase text-gray2">Add new</div>
                </div>
            </div>
        </div>
    );

    function PostBgImage() {
        setShow({loadData: false});
        let obj = `?backgroundType=${'background'}&usrId=${props.match.params.id}`;
        let params = {
            // usrId:props.match.params.id,
            url: showBgImage,
        };
        let accessToken = sessionStorage.getItem('accessToken');
        uploadBackground(obj, params, accessToken).then((res) => {
            // ResponseFilter(res);
            setShow({loadData: true});
            if (res.status === 1) {
                getBGImages();
                setShow({
                    ...show,
                    // uploadBg: '',
                    challengeImageErrorMsg: '',
                    docErrorMsg: '',
                    bgUploadSizeError: false,
                    bgImageExtError: false,
                    uploadBg: false,
                    modalBgDefault: false,
                });
            }
        });
    }

    const SelectBgImage = (e, bgId) => {
        setShowBgValue({
            [e.target.name]: e.target.value,
        });

        setShowBgImage(bgId);
    };
    const AgainBgUpload = () => {
        setShow({
            ...show,
            uploadBg: '',
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            bgUploadSizeError: false,
        });
    };
    const handleBackgroundImage = async (droppedFile) => {
        let reader = new FileReader();
        let img = new Image(droppedFile);
        let file = droppedFile[0];
        let idxDot = file.name.lastIndexOf('.') + 1;
        let extFile = file.name.substr(idxDot, file.name.length).toLowerCase();
        if (extFile == 'jpg' || extFile == 'jpeg' || extFile == 'png') {
            try {
                const dimensions = await imageDimensions(file);
                if (dimensions.width == 1600 && dimensions.height == 1200) {
                    reader.addEventListener(
                        'load',
                        () => {
                            setShow({
                                ...show,
                                uploadBg: reader.result,
                                challengeImageErrorMsg: '',
                                docErrorMsg: '',
                                bgUploadSizeError: false,
                                bgImageExtError: false,
                            });
                        },
                        false
                    );
                    if (file) {
                        reader.readAsDataURL(file);
                        setUploadedBackground(file);
                    }
                } else {
                    setShow({
                        ...show,
                        uploadBg: '',
                        challengeImageErrorMsg: '',
                        docErrorMsg: '',
                        bgUploadSizeError: true,
                    });
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            setShow({
                ...show,
                uploadBg: '',
                challengeImageErrorMsg: '',
                docErrorMsg: '',
                bgImageExtError: true,
            });
        }
    };
    const LogoUploadDone = (e) => {
        var bg = new FormData();
        bg.append('bg', uploadedLogo);
        let obj = `?backgroundType=${'logo'}&usrId=${props.match.params.id}`;
        let accessToken = sessionStorage.getItem('accessToken');
        uploadBackground(obj, bg, accessToken).then((res) => {
            // ResponseFilter(res);
            // setUploadedLogo('');
            ActiveLogo(e, res.data)

            if (res.status === 1) {
                getBGImages();
                setShow({loadData: true});
            }
            setShow({...show, modalLogoDefault: false, uploadLogo: ''});
        });
    };
    const imageDimensions = (file) =>
        new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const {naturalWidth: width, naturalHeight: height} = img;
                resolve({width, height});
            };
            img.onerror = () => {
                reject('There was some problem with the image.');
            };
            img.src = URL.createObjectURL(file);
        });
    const ActiveBg = (e, backgroundId) => {
        setShow({loadData: false});
        setActiveBG({
            ...show,
            [e.target.name]: e.target.value,
        });
        let params = {
            usrId: props.match.params.id,
            backgroundId: backgroundId,
            backgroundType: 'background',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        setBackground(params, accessToken).then((res) => {
            console.log(res, "set bg^^^^^^^^^^^^^^^^^^^^^^^IIIIIIIIII");
            setShow({loadData: true});
            if (res.data.statusCode == 1) {
                getBGImages();
            }
        });
    };

    const ActiveLogo = (e, backgroundId) => {
        setShow({loadData: false});
        setActiveLogo({
            ...show,
            [e.target.name]: e.target.value,
        });
        let params = {
            usrId: props.match.params.id,
            backgroundId: backgroundId,
            backgroundType: 'logo',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        setBackground(params, accessToken).then((res) => {
            // ResponseFilter(res);
            setShow({loadData: true});
            if (res.status == 1) {
                getBGImages();
            }
        });
    };
    const OpenBgModal = () => {
        setShow({...show, modalBgDefault: true});
        setShowBgImage('');
    };

    const CloseBgModal = () => {
        setShow({
            ...show,
            // uploadBg: '',
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            bgUploadSizeError: false,
            bgImageExtError: false,
            uploadBg: false,
            modalBgDefault: false,
        });
    };

    function DeleteBg() {
        setShow({loadData: false});
        let obj = {
            usrId: props.match.params.id,
            backgroundId: show.deleteBgImageId,
            backgroundType: 'background',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        deleteBackground(obj, accessToken).then((res) => {
            // ResponseFilter(res);
            if (res.status === 1) {
                getBGImages();
                setShow({modalBgDelete: false});
                setShow({loadData: true});
            }
        });
    }

    function DeleteLogo() {
        setShow({loadData: false});
        let obj = {
            usrId: props.match.params.id,
            backgroundId: show.deleteLogoImageId,
            backgroundType: 'logo',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        deleteBackground(obj, accessToken).then((res) => {
            // ResponseFilter(res);
            if (res.status === 1) {
                getBGImages();
                setShow({modalLogoDelete: false});
                setShow({loadData: true});
            }
        });
    }

    const OpenBannerDeleteModal = (id, totalLength) => {
        setShow({modalBannerDelete: true, deleteBannerImageId: id});
        if (totalLength === 1) {
            setShow({cantDeleteBanner: true});
        }
    };
    const CloseBannerDeleteModal = () => {
        setShow({...show, modalBannerDelete: false, cantDeleteBanner: false});
    };
    const OpenNumberPlateDeleteModal = (id, totalLength) => {
        setShow({modalNumberPlateDelete: true, deleteNumberPlateImageId: id});
        if (totalLength === 1) {
            setShow({cantDeleteNumberPlate: true});
        }
    };
    const CloseNumberPlateDeleteModal = () => {
        setShow({...show, modalNumberPlateDelete: false, cantDeleteNumberPlate: false});
    };
    const OpenBannerModal = () => {
        setShow({...show, modalBannerDefault: true});
        setShowBannerImage('');
    };
    const CloseBannerModal = () => {
        setShow({
            ...show,
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            bannerUploadSizeError: false,
            bannerImageExtError: false,
            uploadBanner: false,
            modalBannerDefault: false,
        });
    };
    const OpenNumberPlateModal = () => {
        setShow({...show, modalNumberPlateDefault: true});
    };
    const CloseNumberPlateModal = () => {
        setShow({
            ...show,
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            numberPlateUploadSizeError: false,
            numberPlateImageExtError: false,
            uploadNumberPlate: false,
            modalNumberPlateDefault: false,
        });
    };

    const SelectBannerImage = (e, bgId) => {
        setShowBannerValue({
            [e.target.name]: e.target.value,
        });
        setShowBannerImage(bgId);
    };

    const AgainBannerUpload = () => {
        setShow({
            ...show,
            uploadBanner: '',
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            bannerUploadSizeError: false,
        });
    };

    const AgainNumberPlateUpload = () => {
        setShow({
            ...show,
            uploadNumberPlate: '',
            challengeImageErrorMsg: '',
            docErrorMsg: '',
            numberPlateUploadSizeError: false,
        });
    };

    const handleBannerImage = async (droppedFile) => {
        let reader = new FileReader();
        let file = droppedFile[0];
        let idxDot = file.name.lastIndexOf('.') + 1;
        let extFile = file.name.substr(idxDot, file.name.length).toLowerCase();
        if (extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png') {
            reader.addEventListener(
                'load',
                () => {
                    setShow({
                        ...show,
                        uploadBanner: reader.result,
                        challengeImageErrorMsg: '',
                        docErrorMsg: '',
                        bannerUploadSizeError: false,
                        bannerImageExtError: false,
                    });
                },
                false
            );
            reader.readAsDataURL(file);
            setUploadedBanner(file);
        } else {
            setShow({
                ...show,
                uploadBanner: '',
                challengeImageErrorMsg: '',
                docErrorMsg: '',
                bannerImageExtError: true,
            });
        }
    };

    const handleNumberPlateImage = async (droppedFile) => {
        let reader = new FileReader();
        let file = droppedFile[0];
        let idxDot = file.name.lastIndexOf('.') + 1;
        let extFile = file.name.substr(idxDot, file.name.length).toLowerCase();
        if (extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png') {
            reader.addEventListener(
                'load',
                () => {
                    setShow({
                        ...show,
                        uploadNumberPlate: reader.result,
                        challengeImageErrorMsg: '',
                        docErrorMsg: '',
                        numberPlateUploadSizeError: false,
                        numberPlateImageExtError: false,
                    });
                },
                false
            );
            reader.readAsDataURL(file);
            setUploadedNumberPlate(file);
        } else {
            setShow({
                ...show,
                uploadNumberPlate: '',
                challengeImageErrorMsg: '',
                docErrorMsg: '',
                numberPlateImageExtError: true,
            });
        }
    };

    function PostBannerImage() {
        setShow({loadData: false});
        let obj = `?backgroundType=${'banner'}&usrId=${props.match.params.id}`;
        let params = {
            url: showBannerImage,
        };
        let accessToken = sessionStorage.getItem('accessToken');
        uploadBackground(obj, params, accessToken).then((res) => {
            setShow({loadData: true});
            if (res.status === 1) {
                getBGImages();
                setShow({
                    ...show,
                    challengeImageErrorMsg: '',
                    docErrorMsg: '',
                    bannerUploadSizeError: false,
                    bannerImageExtError: false,
                    uploadBanner: false,
                    modalBannerDefault: false,
                });
            } else {
                setShow({
                    ToastMessage: getDisplayMessage(res.data, 'Unable to upload banner'),
                    loadData: true,
                });
            }
        });
    }

    const BannerUploadDone = (e) => {
        setShow({loadData: false});
        let bg = new FormData();
        bg.append('bg', uploadedBanner);
        let obj = `?backgroundType=${'banner'}&usrId=${props.match.params.id}`;
        let accessToken = sessionStorage.getItem('accessToken');
        uploadBackground(obj, bg, accessToken).then((res) => {
            setShow({loadData: true});
            if (res.status === 1) {
                ActiveBanner(e, res.data);
            } else {
                setShow({
                    ToastMessage: getDisplayMessage(res.data, 'Unable to upload banner'),
                });
            }
            setShow({...show, modalBannerDefault: false, uploadBanner: ''});
        });
    };

    const NumberPlateUploadDone = (e) => {
        setShow({loadData: false});
        let bg = new FormData();
        bg.append('bg', uploadedNumberPlate);
        let obj = `?backgroundType=${'number_plate'}&usrId=${props.match.params.id}`;
        let accessToken = sessionStorage.getItem('accessToken');
        uploadBackground(obj, bg, accessToken).then((res) => {
            setShow({loadData: true});
            if (res.status === 1) {
                ActiveNumberPlate(e, res.data);
            } else {
                setShow({
                    ToastMessage: getDisplayMessage(res.data, 'Unable to upload number plate'),
                });
            }
            setShow({...show, modalNumberPlateDefault: false, uploadNumberPlate: ''});
        });
    };

    const ActiveBanner = (e, backgroundId) => {
        setShow({loadData: false});
        setActiveBanner({
            ...show,
            [e.target.name]: e.target.value,
        });
        let params = {
            usrId: props.match.params.id,
            backgroundId: backgroundId,
            backgroundType: 'banner',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        setBackground(params, accessToken).then((res) => {
            setShow({loadData: true});
            if (res.status == 1) {
                getBGImages();
            }
        });
    };

    const ActiveNumberPlate = (e, backgroundId) => {
        setShow({loadData: false});
        setActiveNumberPlate({
            ...show,
            [e.target.name]: e.target.value,
        });
        let params = {
            usrId: props.match.params.id,
            backgroundId: backgroundId,
            backgroundType: 'number_plate',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        setBackground(params, accessToken).then((res) => {
            setShow({loadData: true});
            if (res.status == 1) {
                getBGImages();
            }
        });
    };

    function DeleteBanner() {
        setShow({loadData: false});
        let obj = {
            usrId: props.match.params.id,
            backgroundId: show.deleteBannerImageId,
            backgroundType: 'banner',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        deleteBackground(obj, accessToken).then((res) => {
            if (res.status === 1) {
                getBGImages();
                setShow({modalBannerDelete: false});
                setShow({loadData: true});
            }
        });
    }

    function DeleteNumberPlate() {
        setShow({loadData: false});
        let obj = {
            usrId: props.match.params.id,
            backgroundId: show.deleteNumberPlateImageId,
            backgroundType: 'number_plate',
        };
        let accessToken = sessionStorage.getItem('accessToken');
        deleteBackground(obj, accessToken).then((res) => {
            if (res.status === 1) {
                getBGImages();
                setShow({modalNumberPlateDelete: false});
                setShow({loadData: true});
            }
        });
    }

    const uploadBannerBody = (
        <div>
            <Tabs
                defaultActiveKey="gallery"
                className="breadcrumb-account"
                id="banner-upload-tabs"
            >
                <Tab eventKey="gallery" title="Gallery">
                    <div className="bg-modal-list">
                        <div className="row">
                            {modalBanner.map((item, i) => {
                                return (
                                    <div className="col-md-3 mb-3" key={i}>
                                        <div className="custom-bg-main">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="showBannerValue"
                                                    value={showBannerValue.inputValue}
                                                    onChange={(e) =>
                                                        SelectBannerImage(e, item.backgroundImage)
                                                    }
                                                />
                                                <span></span>
                                            </label>
                                            <div className="custom-bg-in">
                                                <img src={item.backgroundImage} alt="" className="w-100"/>
                                            </div>
                                            {item.label ? <div className="text-center small mt-1">{item.label}</div> : ''}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="text-right">
                        <button
                            className="btn btn-black"
                            disabled={!showBannerImage}
                            onClick={PostBannerImage}
                        >
                            Ok
                        </button>
                    </div>
                </Tab>
                <Tab eventKey="upload" title="Upload">
                    <Dropzone
                        onDrop={(acceptedFile) => handleBannerImage(acceptedFile)}
                        maxSize={400000000}
                    >
                        {({getRootProps, getInputProps}) => (
                            <>
                                {show.uploadBanner ? (
                                    <div>
                                        <img src={show.uploadBanner} alt="" className="w-100"/>
                                        <div className="text-right mt-2">
                                            <button
                                                className="btn btn-black mr-2"
                                                onClick={AgainBannerUpload}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btn-black"
                                                onClick={BannerUploadDone}
                                            >
                                                Ok
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <section>
                                        <div {...getRootProps({className: 'dropzone'})}>
                                            <input {...getInputProps()} />
                                            <UplpadFileIcon/>
                                            <p>Drag & drop banner image here, or click to select</p>
                                            <p className="small text-muted">NOTE: JPG, JPEG or PNG</p>
                                        </div>
                                        {show.bannerImageExtError ? (
                                            <div className="text-danger mt-2">Only jpg, jpeg and png files are allowed.</div>
                                        ) : ''}
                                        {show.bannerUploadSizeError ? (
                                            <div className="text-danger mt-2">Invalid banner image size.</div>
                                        ) : ''}
                                    </section>
                                )}
                            </>
                        )}
                    </Dropzone>
                </Tab>
            </Tabs>
        </div>
    );

    const uploadNumberPlateBody = (
        <Dropzone
            onDrop={(acceptedFile) => handleNumberPlateImage(acceptedFile)}
            maxSize={400000000}
        >
            {({getRootProps, getInputProps}) => (
                <>
                    {show.uploadNumberPlate ? (
                        <div>
                            <img src={show.uploadNumberPlate} alt="" className="w-100"/>
                            <div className="text-right mt-2">
                                <button
                                    className="btn btn-black mr-2"
                                    onClick={AgainNumberPlateUpload}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-black"
                                    onClick={NumberPlateUploadDone}
                                >
                                    Ok
                                </button>
                            </div>
                        </div>
                    ) : (
                        <section>
                            <div {...getRootProps({className: 'dropzone'})}>
                                <input {...getInputProps()} />
                                <UplpadFileIcon/>
                                <p>Drag & drop number plate image here, or click to select</p>
                                <p className="small text-muted">NOTE: JPG, JPEG or PNG</p>
                            </div>
                            {show.numberPlateImageExtError ? (
                                <div className="text-danger mt-2">Only jpg, jpeg and png files are allowed.</div>
                            ) : ''}
                            {show.numberPlateUploadSizeError ? (
                                <div className="text-danger mt-2">Invalid number plate image size.</div>
                            ) : ''}
                        </section>
                    )}
                </>
            )}
        </Dropzone>
    );

    //bg end

    //start plan
    const showPromoBox = () => {
        setShow({promoBox: !show.promoBox});
    };
    const OpenCancelSubscriptionPopup = () => {
        setPopup({cancelSubscriptionPopup: true});
    };
    const OpenDeleteAccountPopup = () => {
        setPopup({deleteAccountPopup: true});
    };

    const CloseCancelSubscriptionPopup = () => {
        setPopup({cancelSubscriptionPopup: false, deleteAccountPopup: false});
    };

    const updateSubscription = (e) => {

        if (show.codeMessageInvalid) {
            // setShow({codeMessageInvalid: "Invalid coupon code"})

        } else {
            setShow({loader: true});

            let obj = {
                usrId: props.match.params.id,
                subscriptionId: updateSubscriptionId[0].id,
                priceId: show.updateStateId,

                couponId: show.promo,
                product: singlePlan.product,
                unitAmount: singlePlan.unit_amount,
                divideBy: singlePlan.divide_by,
                currency: show.currency1,

            };

            let accessToken = sessionStorage.getItem('accessToken');
            updateSubscriptionApi(obj, accessToken).then((res) => {
                // ResponseFilter(res);
                if (res.status == 1) {
                    // updateUserCredit(show.updateStateId);


                    updateUserCredit({updateStateId: show.updateStateId, usrId: props.match.params.id,});


                    setUpdatedSubscription(res.data);
                    setShow({ToastMessageSuccess: ('success_subscribe_plan')});
                    setShow({...show, modalChangePlan: false});
                    getMyUser();
                    getMyBills();
                    setShow({loadData: true, loader: false});
                } else {
                    console.log(res.data.error.errors.raw.message, ";lkjhgfghnjmmmmmmmmmmmmm")

                    // setShow({codeMessageInvalid: (res.data.error && res.data.error.message ? res.data.error.message : (res.data.error.errors.raw.message ? res.data.error.errors.raw.message : ''))});

                    setShow({loader: false});
                    console.log(res, "asssssssszzzzzzzzzzzzzz")

                }
            });
        }
    };

    const dateCoverter = (date) => {
        var theDate = new Date(date * 1000);
        let dateString = theDate.toLocaleDateString();
        return dateString;
    };
    const SelectePlan = (e, id, data) => {
        console.log("###########", e, id, data)

        for (var i = 0; i < planList.length; i++) {
            if (planList[i].id === id) {
                setSinglePlan(planList[i]);
                setShow({planCheck: planList[i]})
            }
        }

        setShow({
            ...show,

            updateStateId: id,
            updatePlan: true,
            activePlanId: id,
        });
    };
    const SelectPack = (e, id, data) => {
        console.log("###########SelectPack", creditList, e, id, data)

        for (var i = 0; i < creditList.length; i++) {
            if (creditList[i]._id === id) {
                setSinglePack(creditList[i]);
                setShow({packCheck: creditList[i]})
            }
        }

        setShow({
            ...show,
            updatePackId: id,
            activePackId: id,
            updatePack: true,
            amountPay: data.amount,

            creditAmount: data.creditAmount,
            carCount: data.carCount,
        });
    };

    const OpenCancelModal = () => {
        setShow({...show, modalCancelPlan: true});
    };
    const CloseCancelModal = () => {
        if (updateSubscriptionId.length > 0) {
            setShow({...show, modalCancelPlan: false});
        } else {
            setShow({ToastMessageSuccess: 'No active plans present.'});
            setShow({...show, modalCancelPlan: false});
        }
    };
    const OpenChangeModal = () => {
        setShow({...show, modalChangePlan: true});
    };
    const CloseChangeModal = () => {
        setShow({
            ...show,
            modalChangePlan: false,
            activePlanId: '',
            updatePlan: false,
            codeMessageInvalid: '',
            promo: '',
            updatePack: false,
        });
    };
    const UpadtePlanModal = () => {
        updateSubscription();
    };

    const OpenSubscribeModal = () => {
        setShow({...show, modalSubscribePlan: true});
    };

    const OpenCreditModal = () => {
        setShow({...show, modalCredit: true});
    };
    const CloseCreditModal = () => {
        setShow({...show, modalCredit: false});
    };
    const OpenFillBillingModal = () => {
        setShow({...show, modalFillBilling: true});
    };
    const OpenCreditPackModal = () => {
        setShow({modalCreditPack: true});
    };

    const CloseSubscribeModal = () => {
        setShow({
            ...show,

            modalSubscribePlan: false,
            promo: '',
            promoBox: false,
            codeMessageInvalid: '',
            codeMessage: '',
            activePlan: false,
            activePlanId: '',
            modalCreditPack: false,
            percentOff: '',
            activePackId: '',
            modalFillBilling: false,

            activePack: false

        });
        setSinglePlan([]);
        setSinglePack([]);

        getMyUser();
    };
    const showMorePlans = () => {
        setSeeListItem(seeListItem + 15);
    };
    const showLessPlans = () => {
        setSeeListItem(5);
    };
    const CancelPlanContent = (
        <>
            <p>{('You are about to cancel your subscription plan at Optifo. If  you cancel, remaining credits will be invalidated at the end of your current billing period.')}</p>
        </>
    );
    const ChangePlanContent = (
        <>
            {updateSubscriptionId ? (
                <p>
                    {('You’re upgrading your plan to ### credits/month')}
                    <strong>{('We’ll charge you 125 kr. (taxes included) now')}</strong>,{' '}
                    {('for current billing period.')}
                </p>
            ) : (
                ''
            )}
            {updateSubscriptionId ?
                <p>{('Starting from November 30, 2020 and until you cancel, we’ll bill you once a month and your new monthly total will be 623,75 kr. (taxes included). If you cancel, previous charges won’t be refunded.')}</p> : ''}

            {show.promoBox ?
                <div className=" pt-3">
                    <div className=" justify-content-between">

                        <div
                            className={`form-group md-custom-form ${
                                show.promoError ? 'error' : ''
                            }`}
                        >
                            <MDBInput
                                PlaceHolder={('Code')}
                                type="text"
                                className="form-control input-lg"
                                name="promo"
                                maxLength={"35"}

                                value={show.promo}
                                onChange={(e) => handelPromoOnChange(e, 1)}
                            />
                            {show.codeMessage ? (<span className="small text-gray pl-3">
                                        <p>
                                            {show.codeMessage}</p>
                                    {show.percentOff ? <p>You will get {show.percentOff}% off.</p> : ''}

                                </span>

                            ) : (<InlineError errorMessage={show.codeMessageInvalid}/>

                            )}
                        </div>
                    </div>
                </div> : ''}

        </>


    );
    const sendResultStripe = async (result) => {
        setShow({activePlanId: ''});
        let customerId = show.stripeCustomerId;

        if (!customerId) {
            console.log(userInput, show, "MKKKKKKKKKKKKKKKKKKKKKKK")


            let {
                currency,
                additionalEmail,
                userCompanyName,
                vatPercent,
                streetAddress,
                suitUnit,
                stateProvince,
                city,
                postalCode,
                vatNumber,
                country,
                userCompanyName1,
            } = userInput;

            let obj = {
                additionalEmail: additionalEmail,
                usrId: props.match.params.id,
                email: show.userEmail ? show.userEmail : show.userEmail1,
                firstName: show.userName,
                fullName: show.userName,

                vatPercent: vatPercent,
                currency: currency,
                companyDetails: {
                    companyName: userCompanyName ? userCompanyName : userCompanyName1,
                    currency: currency,
                    city: singleAddress.showCity == 1 ? city : '',
                    country,
                    state: singleAddress.showState == 1 ? stateProvince : '',
                    streetAddress: streetAddress,
                    suit: suitUnit,
                    postalCode: singleAddress.showPostal == 1 ? Number(postalCode) : '',
                    VatNo: singleAddress.showVat == 1 ? vatNumber : '',
                },
            };

            let accessToken = sessionStorage.getItem('accessToken');
            userProfileUpdate(obj, accessToken).then((res) => {

                setShow({loadData: false});
                if (res.status == 1) {
                    // setShow({ToastMessageSuccess: res.data.responseData.message});
                    setNotification(true);
                    setShow({companyNameBox: false, companyBox: false});

                }
            });


            let getCustomer = await createStripeCustomer(obj);
            // let getCustomer ={}
            console.log(getCustomer, "getCustomergetCustomer1")

            if (getCustomer.data.user.id) {
                setShow({stripeCustomerId: getCustomer.data.user.id});
                customerId = getCustomer.data.user.id;
            }

            console.log(getCustomer, "getCustomergetCustomer2")
        }
        let obj = {
            customerId: customerId,
            source: result,
        };
        console.log(customerId, "getCustomergetCustomer3")

        let accessToken = sessionStorage.getItem('accessToken');
        addCard(obj, accessToken).then((response) => {
            console.log(response, "ssssssssssssssssssss>>>>>>>>s111111")
            if (response.status == 1) {
                UpdateNames()
                console.log(response.data, "nxxxxxxxxxxxxxxxxresponse.data.responseData paymentmethid")
                getCompanyInfo()
                getMyCards(response.data.id, customerId)
                getTabValue(3)

                // createStripeSubscription(response.data.responseData);
            } else {
                setShow({ToastMessage: 'Could not add card'});
            }
        });
    };
    const handelPromoOnChange = (e, type) => {
        setShow({loadData: true, loader: false, percentOff: '', codeMessageInvalid: '', codeMessage: ''});

        console.log(e.target.value, "Asdashhhhhhh", type,)
        if (e.target.value.length) {

            let params = ``;
            couponsListService(params).then((response) => {
                console.log(response, "adddddddddd", show.codeMessageInvalid)
                if (response.status == 1) {
                    let list = response.data.list
                    // setShow({couponList: })
                    list.map((val, i) => {
                        console.log(val.id, e.target.value, val.id === e.target.value, "sdasdasdasd", e.target.value, "ssssssssssssssssssssasasda")
                        if (e.target.value) {
                            let a = []
                            list.forEach(function (obj) {
                                a.push(obj.id);
                            })

                            let exist = a.includes(e.target.value); // true
                            if (!exist) {
                                setShow({codeMessageInvalid: "Coupon code does not exist"})

                            }
                            console.log(e.target.value, val.id, type, exist, "sdasdasdasdssssssssssdffffff")
                        }


                        if (val.id === e.target.value) {

                            let math = Math.floor(Date.now() / 1000);
                            if (val.id === e.target.value && val.valid) {

                                // if (val.id === e.target.value && (val.redeem_by > math || val.redeem_by == null) && (val.times_redeemed < val.max_redemptions)) {
                                console.log(type, "typeeeeeeeeeeeee", val.metadata)
                                // if (type == val.metadata.type) {
                                //     if (type == (val.metadata.type) || (val.metadata.type == "3" || val.metadata.type == 3)) {
                                if (type == (val.metadata.type) || (val.metadata.type == "3" || val.metadata.type == 3)) {

                                    if (val.metadata && val.metadata.emails) {

                                        let emails = (val.metadata.emails)
                                        emails = emails.split(",")
                                        var n = emails.includes(show.userEmail);
                                        if (n) {
                                            console.log("PReeeeeeeeee", val.percent_off, val,)
                                            setShow({
                                                codeMessage: "Code is applied",
                                                codeMessageInvalid: '',
                                                percentOff: val.percent_off
                                            })
                                        } else {
                                            setShow({codeMessageInvalid: "This coupon code is not valid for you",})
                                        }


                                    } else {
                                        setShowCoupon(1)

                                        setShow({
                                            codeMessage: "Code is applied",
                                            percentOff: val.percent_off,
                                            codeMessageInvalid: ''
                                        })
                                    }
                                } else {
                                    setShow({codeMessageInvalid: "Coupon code is not valid for this product"})
                                }
                            } else {
                                setShow({codeMessageInvalid: "Coupon code expired"})
                            }


                        }
                        // else if(val.id !== e.target.value){
                        //     console.log(val.id !== e.target.value,val.id , e.target.value,"sdasdasdasdssssssssssdffffff")
                        //          setShow({codeMessageInvalid: "Invalid coupon code "})
                        //      }

                    })

                } else {
                    setShow({ToastMessage: (response.data.error.message)});
                    setShow({loader: false,});
                    showNotification();
                }
            });
        }

        setShow({

            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: '',
        });
    };


    const handleCheckout = () => {

        let percent = show.percentOff ? ((show.amountPay / 100) * show.percentOff).toFixed(2) : 0;
        let taxPay = (userInput.taxStatus == 2 ? 0 : ((show.amountPay / 100) * (userInput.vatPercent?userInput.vatPercent:0)));
        let pay = (show.amountPay - percent) + taxPay;
        if (show.codeMessageInvalid) {
            // setShow({codeMessageInvalid: "Invalid coupon code "})
        } else {
            let pay1=((pay).toFixed(2)).toString();

            let obj = {
                usrId: props.match.params.id,
                packId: show.activePackId,
                couponId: show.promo,
                couponOff: percent,
                percentOff: show.percentOff ? show.percentOff : 0,
                email: show.userEmail,
                subTotal: show.amountPay,
                creditAmount: show.creditAmount,
                tax: taxPay.toFixed(2),
                amount: Math.ceil(pay1*100),
                carCount: show.carCount,
                vatPercent: userInput.vatPercent?userInput.vatPercent:0,
                paymentMethodId: cardDetails.id,
                currency: show.currency1,
            };

            let accessToken = sessionStorage.getItem('accessToken');
            if (show.promo) {
                let par = `?couponId=${show.promo}`

                getCouponById(par, accessToken).then((resp) => {
                    console.log(resp, "Sdddddddddd",)
                    // console.log(resxz, "Sdddddddddd",)

                    if (resp.data.list.errors && resp.data.list.errors.raw.message) {
                        setShow({codeMessageInvalid: resp.data.list.errors.raw.message})
                        console.log("1sssssssssssssxxxxxxc")

                    } else if (!resp.data.list.valid) {
                        console.log("2sssssssssssssxxxxxxc")

                        setShow({codeMessageInvalid: "This coupon code is expired."})

                    }
                    else{

                        console.log("3sssssssssssssxxxxxxc")

                        createCharge(obj, accessToken).then((response) => {

                            console.log(response, "createCharge")
                            setShow({loader: false});
                            if (
                                response.status == 1) {

                                CloseSubscribeModal();
                                setShow({
                                    ...show,
                                    updatePackId: '',
                                    updatePack: false,
                                    amountPay: '',

                                    creditAmount: '',
                                    carCount: '',
                                    loadData: true,
                                    modalCreditPack: false,
                                    activePackId: '',
                                    modalSubscribePlan: false,
                                    promo: '',
                                    percentOff: '',
                                    // singlePack:'',
                                    promoBox: false,
                                    codeMessageInvalid: '',
                                    codeMessage: '',
                                    activePlan: false,
                                    activePack: false,
                                    activePlanId: '',

                                });

                                setSinglePack([])


                                // showNotification();
                                saveCreditPack(2, show.creditAmount);

                                // updateUserPackCredit(show.creditAmount, show.creditAmount);
                                getMyUser();
                                getMyBills();

                            } else {
                                if (response.data.error.errors.status == "succeeded") {
                                    console.log(response,"SAaaaaaaaaa22")

                                }
                                else {
                                    console.log(response,"SAaaaaaaaaa3333333")

                                    if( response.data.error.errors.client_secret==undefined &&response.data.error.errors.raw.message ){

                                        console.log(response,"SAaaaaaaaaa44444")
                                        setShow({codeMessageInvalid:response.data.error.errors.raw.message?response.data.error.errors.raw.message: 'zxz'})

                                        setShow({loader: false, errorMessage: response.data.error.errors.raw.message});

                                    }else {
                                        console.log(response,"SAaaaaaaaaa555555555")

                                        props.stripe.confirmCardPayment(response.data.error.errors.client_secret, {
                                            payment_method: response.data.error.errors.last_payment_error.payment_method ? response.data.error.errors.last_payment_error.payment_method.id : response.data.error.errors.last_payment_error.source.id
                                        }).then((res) => {
// if()
                                            if (res.error) {
                                                CloseSubscribeModal();
                                                // OpenFailurePaymentPopup(res.error.message);
                                                // Show error to your customer
                                            } else {
                                                if (res.paymentIntent.status === 'succeeded') {
                                                    createChargeByAuthenticatedCard(obj, accessToken).then((response) => {



                                                        if (response.data.statusCode == 1) {

                                                            CloseSubscribeModal();
                                                            // OpenSuccessPaymentPopup();

                                                            setShow({
                                                                ...show,
                                                                updatePackId: '',
                                                                updatePack: false,
                                                                amountPay: '',
                                                                creditAmount: '',
                                                                carCount: '',
                                                                loadData: true,
                                                                modalCreditPack: false,
                                                                activePackId: '',
                                                                modalSubscribePlan: false,
                                                                promo: '',
                                                                percentOff: '',
                                                                promoBox: false,
                                                                codeMessageInvalid: '',
                                                                codeMessage: '',
                                                                activePlan: false,
                                                                activePack: false,
                                                                activePlanId: '',

                                                            });

                                                            saveCreditPack(2, show.creditAmount);

                                                            getMyUser();
                                                            getMyBills();

                                                        }
                                                    })
                                                }
                                            }
                                        });

                                    }
                                    setShow({loader: false,})


                                }
                                setShow({loader: false,})
                            }
                        }).catch(err => {
                            setShow({codeMessageInvalid: err.data.error && err.data.error.errors && err.data.error.errors.raw.message ? err.data.error.errors.raw.message : ''})

                            console.log(err,)
                        })


                    }
                })
            }
            else {
            createCharge(obj, accessToken).then((response) => {

                console.log(response, "Sdddddddddddddddddddxczzzzzzzzzzzzz")
                setShow({loader: false});
                if (
                    response.status == 1) {
                    console.log(response,"SAaaaaaaaaa")

                    setShow({


                        ...show,
                        updatePackId: '',
                        updatePack: false,
                        amountPay: '',
                        creditAmount: '',
                        carCount: '',
                        percentOff: '',
                        activePlanId: '',
                        loadData: true,
                        modalCreditPack: false, activePackId: '',
                        modalSubscribePlan: false,
                        promo: '',
                        promoBox: false,
                        codeMessageInvalid: '',
                        codeMessage: '',
                        activePlan: false,
                        activePack: false,


                    });
                    console.log(show.amountPay, "ssssssssssssdsssssssssssamount")
                    // showNotification();
                    saveCreditPack(2, show.creditAmount);
                    getMyUser();
                    // getPlansList();
                    getMyBills();

                } else {
                    console.log(response,"SAaaaaaaaaa1111111")

                    if (response.data.error.errors.status == "succeeded") {
                        console.log(response,"SAaaaaaaaaa22")

                    }
                    else {
                        console.log(response,"SAaaaaaaaaa3333333")

                        if( response.data.error.errors.client_secret==undefined &&response.data.error.errors.raw.message ){

                            console.log(response,"SAaaaaaaaaa44444")
                            setShow({codeMessageInvalid:response.data.error.errors.raw.message?response.data.error.errors.raw.message: 'zxz'})

                            setShow({loader: false, errorMessage: response.data.error.errors.raw.message});

                        }else {
                            console.log(response,"SAaaaaaaaaa555555555")

                            props.stripe.confirmCardPayment(response.data.error.errors.client_secret, {
                                payment_method: response.data.error.errors.last_payment_error.payment_method ? response.data.error.errors.last_payment_error.payment_method.id : response.data.error.errors.last_payment_error.source.id
                            }).then((res) => {
// if()
                                if (res.error) {
                                    CloseSubscribeModal();
                                    // OpenFailurePaymentPopup(res.error.message);
                                    // Show error to your customer
                                } else {
                                    if (res.paymentIntent.status === 'succeeded') {
                                        createChargeByAuthenticatedCard(obj, accessToken).then((response) => {



                                            if (response.data.statusCode == 1) {

                                                CloseSubscribeModal();
                                                // OpenSuccessPaymentPopup();

                                                setShow({
                                                    ...show,
                                                    updatePackId: '',
                                                    updatePack: false,
                                                    amountPay: '',
                                                    creditAmount: '',
                                                    carCount: '',
                                                    loadData: true,
                                                    modalCreditPack: false,
                                                    activePackId: '',
                                                    modalSubscribePlan: false,
                                                    promo: '',
                                                    percentOff: '',
                                                    promoBox: false,
                                                    codeMessageInvalid: '',
                                                    codeMessage: '',
                                                    activePlan: false,
                                                    activePack: false,
                                                    activePlanId: '',

                                                });

                                                saveCreditPack(2, show.creditAmount);

                                                getMyUser();
                                                getMyBills();

                                            }
                                        })
                                    }
                                }
                            });

                        }
                        setShow({loader: false,})


                    }
                    setShow({loader: false,})
                }
            }).catch(err => {
                setShow({codeMessageInvalid: err.data.error && err.data.error.errors && err.data.error.errors.raw.message ? err.data.error.errors.raw.message : ''})

                console.log(err, "Ssssssdddddddddddddddddddddddddd")
            })

        }
        }
    }

    const createStripeSubscription = (result) => {

        console.log(cardDetails, "createStripeSubscription")

        console.log(show.codeMessageInvalid, "show.codeMessageInvalidshow.codeMessageInvalid")
        if (show.codeMessageInvalid) {

        } else {
            setShow({loader: true});
            if (!result) {
                setShow({ToastMessage: 'Could not add card'});
            }
            console.log("ssssssss", show, singlePlan, "ssssssssssssssssssssssshow")
            console.log("ssssssss", "sssssssssssssssssssssszxshow")


            console.log("ssdsdf", show.promo)
            // console.log("ssdsdfsas", show.sasa)

            let obj = {
                couponId: show.promo,
                usrId: props.match.params.id,
                priceId: show.updateStateId,
                paymentMethodId: cardDetails.id,
                product: singlePlan.product,
                unitAmount: singlePlan.unit_amount,
                divideBy: singlePlan.divide_by,
                currency: show.currency1,
                // paymentMethodId: result.id,
            };

            let accessToken = sessionStorage.getItem('accessToken');
            // console.log("sssssssssss",ssssssss)

            createSubscription(obj, accessToken).then((response) => {

                console.log(response, "Dddddddddddddddds")
                setShow({loadData: true, loader: false});
                if (
                    response.status == 1) {
                    setShow({modalSubscribePlan: false})
                    props.stripe.handleCardPayment(response.data.responseData.latest_invoice.payment_intent.client_secret)
                        .then(function (result) {
                            console.log(result, "RRRRRRRRRRRRRRRRRRRRRRRrr")
                            if ((result.paymentIntent && result.paymentIntent.status == 'succeeded') || result.error.payment_intent.status == 'succeeded') {

                                setShow({
                                    modalSubscribePlan: false,
                                    ToastMessageSuccess: ('success_subscribe_plan'),
                                    activePlanId: '',
                                });

                                showNotification();
                                updateUserCredit({updateStateId: show.updateStateId, usrId: props.match.params.id,});
                                getMyUser();
                                // getPlansList();
                                getMyBills();
                            } else {
                                setShow({
                                    modalSubscribePlan: false,
                                    ToastMessage: (result.error.message),
                                    codeMessageInvalid: result.error.message
                                });
                                showNotification();
                            }
                        });
                } else {
                    console.log(response, "Ssssssdddddddddddddddddddddddddd", response.data.error.errors.raw.message)
                    setShow({ToastMessage: (response.data.error && response.data.error.message ? response.data.error.message : (response.data.error.errors.raw.message ? response.data.error.errors.raw.message : ''))});
                    setShow({codeMessageInvalid: (response.data.error && response.data.error.message ? response.data.error.message : (response.data.error.errors.raw.message ? response.data.error.errors.raw.message : ''))});
                    setShow({loader: false, activePlanId: ''});
                    showNotification();
                }
            }).catch(err => {
                console.log(err, "Ssssssdddddddddddddddddddddddddd")
            })
        }
    };
    const saveCreditPack = (type, cred) => {
        let accessToken = sessionStorage.getItem('accessToken');

        console.log(show.credit, show.creditError, "XCVVVVVVVVVVVvvv")

        if (type == 2) {
            let obj = {
                "usrId": props.match.params.id,
                "leftPackCredits": cred,
                "totalPackCredits": cred,
            };

            updatePackCredit(obj, accessToken).then((response) => {

                console.log(response, "Dddddddddddddddds")
                setShow({loadData: true, loader: false});
                if (response.status == 1) {

                    console.log(response, "RRRRRRRRRRRRRRRRRRRRRRRrr")

                    setShow({
                        modalCredit: false,
                        credit: ''
                    });
                    getMyUser();


                } else {
                    setShow({creditError: (response.data.error && response.data.error.message ? response.data.error.message : '')});
                    setShow({loader: false});
                }
            }).catch(err => {
                console.log(err, "Ssssssdddddddddddddddddddddddddd")
            })
        } else {

            if (!show.credit) {
                setShow({creditError: "Please enter credits"})

            } else {
                setShow({loader: true});
                console.log("ssssssss", show.credit, "creditcreditssssssssssssssssssssssshow")
                console.log("ssssssss", "sssssssssssssssssssssszxshow")
                let cred = Number(show.credit)

                let obj = {
                    "usrId": props.match.params.id,
                    "leftPackCredits": cred,
                    "totalPackCredits": cred,
                };

                // console.log("sssssssssss",ssssssss)

                updatePackCredit(obj, accessToken).then((response) => {

                    console.log(response, "Dddddddddddddddds")
                    setShow({loadData: true, loader: false});
                    if (response.status == 1) {

                        console.log(response, "RRRRRRRRRRRRRRRRRRRRRRRrr")

                        setShow({
                            modalCredit: false,
                            credit: ''
                        });
                        getMyUser();


                    } else {
                        setShow({creditError: (response.data.error && response.data.error.message ? response.data.error.message : '')});
                        setShow({loader: false});
                    }
                }).catch(err => {
                    console.log(err, "Ssssssdddddddddddddddddddddddddd")
                })
            }
        }

    };

    const createOptions = () => {
        return {
            style: {
                base: {
                    fontSize: '16px',
                    color: '#424770',
                    letterSpacing: '0.025em',
                    '::placeholder': {
                        color: '#888888',
                    },
                },
                invalid: {
                    color: '#c23d4b',
                },
            },
        };
    };
    const SubscribePlanData = (
        <>
            <Form onSubmit={createStripeSubscription}>

                <h5 className=" mb-2">
                    {('Credit card')}
                </h5>
                {cardDetails && cardDetails.last4 ? <div
                    className="d-flex visa-card align-items-center mb-3">
                    {console.log(cardDetails && cardDetails.last4, "ssssssssssssssssssss")}
                    <img src={show.brandImage} alet="Visa"/>
                    <span className="pl-3">•••• •••• •••• </span>
                    {cardDetails && cardDetails.last4 ? <span className="pl-2">{cardDetails.last4}</span> : ''}
                </div> : ''}
                {/*</Form>*/}
                <div className="form-group border-top pt-3">
                    <div className="d-flex justify-content-between">
                        {singlePlan.length !== 0 ? (
                            <span>
              {singlePlan.transform_quantity.divide_by} {('credits')} /{' '}
                                {('month')}
            </span>
                        ) : (
                            ''
                        )}
                        <span>+ {('VAT')} (25%)</span>
                    </div>
                    <div className="d-flex justify-content-between">
                        {singlePlan.length !== 0 ? (
                            <span>{(singlePlan.unit_amount / 100).toFixed(2)} {singlePlan.currency ? singlePlan.currency.toUpperCase() : singlePlan.currency}</span>

                        ) : (
                            ''
                        )}
                        {singlePlan.length !== 0 ? (
                            <span>{(singlePlan.unit_amount / 10000) * 25}</span>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <div className="border-top pt-3 ">
                    <div className="d-flex justify-content-between">
                        <strong>{('Total')}</strong>
                        {singlePlan.length !== 0 ? (
                            <strong>
                                {((singlePlan.unit_amount / 100) +
                                    (singlePlan.unit_amount / 10000) * 25).toFixed(2)}{' '} {singlePlan.currency ? singlePlan.currency.toUpperCase() : singlePlan.currency}

                            </strong>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                {/*//input code*/}
                {show.promoBox ?
                    <div className=" pt-3">
                        <div className=" justify-content-between">

                            <div
                                className={`form-group md-custom-form ${
                                    show.promoError ? 'error' : ''
                                }`}
                            >
                                <MDBInput
                                    placeHolder={('Code')}
                                    type="text"
                                    maxLength={"35"}

                                    className="form-control input-lg"
                                    name="promo"
                                    value={show.promo}
                                    onChange={(e) => handelPromoOnChange(e)}
                                />
                                {show.codeMessage ? (<span className="small text-gray pl-3">{show.codeMessage}</span>

                                ) : (<InlineError errorMessage={show.codeMessageInvalid}/>

                                )}
                            </div>
                        </div>
                    </div> : ''}
            </Form>
        </>
    );


    const SubscribePackData = (
        <>
            <Form onSubmit={handleCheckout}>

                <h5 className=" mb-2">
                    {('Credit card')}
                </h5>
                {cardDetails && cardDetails.last4 ? <div
                    className="d-flex visa-card align-items-center mb-3">
                    <img src={show.brandImage} alt="Visa"/>
                    <span className="pl-3">•••• •••• •••• </span>
                    {cardDetails && cardDetails.last4 ? <span className="pl-2">{cardDetails.last4}</span> : ''}
                </div> : ''}
                {/*</Form>*/}
                <div className="form-group border-top pt-3">
                    <div className="d-flex justify-content-between">
                        {singlePack.length !== 0 ? (
                            <span>
                                {singlePack.creditAmount ? singlePack.creditAmount.toFixed() : ''} credits

            </span>
                        ) : (
                            ''
                        )}

                        {singlePack.length !== 0 ? (
                            <span>{singlePack.amount}
                                {singlePack.currency ? singlePack.currency.toUpperCase() : singlePack.currency}
                            </span>
                        ) : (
                            ''
                        )}


                    </div>

                    <div className="d-flex justify-content-between">

                        {show.percentOff ? <span>

{"Discount applied"} {show.percentOff}%

</span> : ''}

                        <span>
                {show.percentOff ? "-" : ''}{show.percentOff ? (show.percentOff * (singlePack.amount / 100)).toFixed(2) : ''}
</span>
                    </div>

                    {userInput.taxStatus == 2 ? "" : <div className="d-flex justify-content-between">
                        <span>+ VAT ({userInput.vatPercent?userInput.vatPercent:0}%)</span>


                        {singlePack.length !== 0 ? (

                            <span>{singlePack.amount ? (((singlePack.amount- (show.percentOff * (singlePack.amount / 100)).toFixed(2))/ 100) * (userInput.vatPercent?userInput.vatPercent:0)).toFixed(2) : ''}</span>
                        ) : (
                            ''
                        )}

                    </div>}
                </div>
                <div className="border-top pt-3 ">
                    <div className="d-flex justify-content-between">
                        <strong>{('Total')}</strong>
                        {singlePack.length !== 0 ? (
                            <strong>
                                {((singlePack.amount + (userInput.taxStatus == 2 ? 0 : (((singlePack.amount -(show.percentOff * (singlePack.amount / 100)).toFixed(2))/ 100) * (userInput.vatPercent?userInput.vatPercent:0)))) - (show.percentOff * (singlePack.amount / 100)).toFixed(2)).toFixed(2)}{' '}{singlePack.currency ? (singlePack.currency).toUpperCase() : ''}

                            </strong>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <p className="pack">When you buy the pack, you accept that Optifo will automatically refill when you run
                    out of credits. You can always disable this later.</p>
                {/*//input code*/}
                {show.promoBox ?
                    <div className=" pt-3">
                        <div className="input-w-icon justify-content-between">

                            <div
                                className={`form-group md-custom-form mb-0 ${
                                    show.promoError ? 'error' : ''
                                }`}
                            >
                                <MDBInput
                                label="Enter code"
                                    placeholder={('Code')}
                                    type="text"
                                    maxLength={"35"}
                                    disabled={showCoupon == 2 ? true : false}

                                    className="form-control input-lg"
                                    name="promo"
                                    value={showCoupon == 2 ? "XXXXXXX" : show.promo}
                                    onChange={(e) => handelPromoOnChange(e, 2)}
                                />
                            </div>


                            <span className="cross-icon close">{show.promo ? <span
                                title={"Discount will not be applied if you remove the coupon or you try with another coupon code"}
                                onClick={() => handleCouponRemove()}
                            >
                  <CloseIcon/>
                </span> : ''}</span>

                            <span>{show.codeMessage ? (<small className=" text-gray pl-3">

                                    {show.codeMessage}

                                </small>

                            ) : (<InlineError errorMessage={show.codeMessageInvalid}/>

                            )}</span>
                        </div>
                    </div> : ''}
            </Form>
        </>
    );

    const CreditModalData = (
        <>
            <Form onSubmit={saveCreditPack}>
                {/*<Form onSubmit={UpdateSubscribeModal}>*/}

                <h5 className=" mb-2">
                    {/*{('Add credits')}*/}
                </h5>

                <div className=" pt-3">
                    <div className=" justify-content-between">

                        <div
                            className={`form-group md-custom-form ${
                                show.creditError ? 'error' : ''
                            }`}
                        >
                            <label>Enter credits</label>
                            <MDBInput
                                placeholder="Enter credits"
                                type="number"
                                maxLength={"100"}
                                max={"100"}

                                className="form-control input-lg"
                                name="credit"
                                value={show.credit}
                                onChange={(e) => handelCreditChange(e)}
                            />

                            {show.creditError ? <InlineError errorMessage={show.creditError}/> : ''}
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
    const cancelSubscriptionDelete = () => {
        setCancelLoader(true);

        let obj = {
            usrId: props.match.params.id,
            subscriptionId: updateSubscriptionId[0].id,
        };
        if (show.codeMessageInvalid) {

        } else {
            cancelSubscriptionApi(obj).then((res) => {
                // ResponseFilter(res);
                CloseCancelSubscriptionPopup();
                setCancelLoader(false);
                if (res.status == 1) {
                    OpenDeleteAccountPopup();
                    setShow({ToastMessageSuccess: 'Successfully cancelled plan'});
                    getMyUser();
                    // getPlansList();
                    getMyBills();
                    setShow({loadData: true, activePlanId: ''});
                    setCancelLoader(false);
                }
            });
        }
    };

    const cancelSubscription = () => {
        setCancelLoader(true);
        let obj = {
            subscriptionId: updateSubscriptionId[0].id,
        };

        let accessToken = sessionStorage.getItem('accessToken');
        cancelSubscriptionApi(obj, accessToken).then((res) => {
            CloseCancelModal();
            setCancelLoader(false);
            if (res.status == 1) {
                setShow({ToastMessageSuccess: 'Successfully cancelled plan'});
                getMyUser();
                // getPlansList();
                getMyBills();
                setShow({loadData: true, activePlanId: ''});
                setCancelLoader(false);
            }
        });
    };

    const UpdateSubscribeModal = async (e) => {
        e.preventDefault();
        setShow({...show, modalSubscribePlan: false});
        console.log( "errorMessageerrorMessagexxxxxxxxxxx1")

        if (handleValidation()) {
            console.log(props.stripe, "errorMessageerrorMessagexxxxxxxxxxx2")

            if (props.stripe) {

                console.log(props.stripe, "errorMessageerrorMessagexxxxxxxxxxx3")
                let name = show.userName
                props.stripe.createToken({name: name}).then((res) => {
                    console.log(res.error, 'errorMessageerrorMessageernfdmc')

                    if (res.error) {
                        setShow({loader: false, errorMessage: res.error.message});
                    } else {
                        let cardToken = res.token.id;

                        sendResultStripe(cardToken);
                        let req = {
                            token: cardToken,
                            amount: 'rr',
                        };
                    }
                });
            }
        }
    };
    const updateBillingInfo = (e) => {
        console.log(e, "dddddddddddhhhhhh")
        if (e.error) {
            setShow({errorMessage: e.error.message});
        } else {
            setShow({
                ...show, errorMessage: '',
                [e.target.name]: e.target.value,
            });
        }


    }

    const upadteBillingInfo = (
        <>
            <div className="form-group">
                <CardNumberElement
                    label={'Credit card number'}
                    type="text"
                    className="form-control input-lg"
                    name="creditNumberBilling"
                    value={show.creditNumberBilling}
                    onChange={updateBillingInfo}
                />
            </div>
            <div className="row custom-row">
                <div className="col-sm-8">
                    <div className="form-group">
                        <CardExpiryElement
                            label={('Expiration date')}
                            type="text"
                            className="form-control input-lg"
                            name="expiryDateBilling"
                            value={show.expiryDateBilling}
                            onChange={updateBillingInfo}
                        />
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="form-group">
                        <CardCVCElement
                            label={('security code')}
                            type="text"
                            className="form-control input-lg"
                            name="securityCode"
                            value={show.securityCode}
                            onChange={updateBillingInfo}
                        />
                    </div>
                </div>
            </div>
        </>
    );
    const OpenBillingModal = () => {
        setShow({...show, modalBilling: true});
    };
    const CloseBillingModal = () => {
        setShow({...show, errorMessage: '', modalBilling: false});
    };
    const getMyCards = (cardId, customerId) => {
        let params = {
            cardId: cardId,
            customerId: customerId,
        };
        let accessToken = sessionStorage.getItem('accessToken');
        getCard(params, accessToken).then((res) => {
            if (res.status == 1) {

                console.log(res, "Sddddddddddddddddd")
                setCardDetails(res.data);
                getBrandImage(res.data.brand);
            }
        });
    };
    const handleChange = ({error}) => {
        if (error) {
            setShow({errorMessage: error.message});
        } else {
            setShow({errorMessage: ''});
        }
    };
    const updateCard = async () => {
        try {
            let name = show.userName
            // if (handleValidation()) {
            const tokenResponse = await props.stripe.createToken({name: name});

            console.log(tokenResponse, "1sddddddddddddRessssssssssss")
            if (tokenResponse.error) {
                setShow({loader: false, cardError: tokenResponse.error.message});
            } else {
                console.log(tokenResponse, "2sddddddddddddRessssssssssss")
                let obj = {
                    customerId: show.stripeCustomerId,
                    usrId: props.match.params.id,
                    cardId: tokenResponse.token.card.id,
                    source: tokenResponse.token.id,
                };
                console.log("3LLLLLLLLLLLLsddddddddddddRessssssssssss", obj);

                let accessToken = sessionStorage.getItem('accessToken');
                updateStripeCard(obj, accessToken).then((res) => {
                    console.log("4LLLLLLLLLLLLsddddddddddddRessssssssssss", res);
                    CloseBillingModal();
                    if (res.status === 1) {
                        UpdateNames()
                        setShow({errorMessage: ''});
                        setShow({ToastMessageSuccess: ('card succesfully updated')});
                        getMyBills();
                        getMyCards(res.data.id, show.stripeCustomerId);
                        // getMyUser();
                        setShow({loadData: true});
                    } else {
                        setShow({ToastMessage: ('an Error Occured!')});
                    }
                });

            }
        } catch (e) {
            setShow({ToastMessage: ('an Error Occured!')});
            showNotification();
            CloseBillingModal();
        }
    };

    function handleEmailValidation() {
        let validate = true;

        if (show.newEmail === '') {
            validate = false;
            setShow({newEmailError: `${('Please enter email')}`});
        } else if (!validateEmail(show.newEmail).status) {
            validate = false;
            setShow({newEmailError: `${('Please enter valid email')}`});
        }

        if (show.confrimEmail === '') {
            validate = false;
            setShow({confrimEmailError: `${('Please enter email')}`});
        } else if (!validateEmail(show.confrimEmail).status) {
            validate = false;
            setShow({confrimEmailError: `${('Please enter valid email')}`});
        } else if (show.confrimEmail !== show.newEmail) {
            validate = false;
            setShow({confrimEmailError: `${(' New email and confirm email should be same')}`});
        }

        if (show.optifoPasswod.trim() === '') {
            validate = false;
            setShow({optifoPasswodError: `${('Please enter password')}`});
        } else if (!validatePassword(show.optifoPasswod.trim()).status) {
            validate = false;
            setShow({optifoPasswodError: `${('Please enter valid password')}`});
        }

        if (show.password == show.optifoPasswod) {
            validate = false;
            setShow({optifoPasswodError: `${('Password is not correct')}`});
        }

        return validate;
    }

    const UpdateCurrency = (e) => {
        console.log(e, "PPP>>>>>xxxxxxxxx", userInput.currency, "Dddddddddd")
        if (e == 1) //currency
        {
            if (userInput.currency === ' ') {
                setUserInput({currencyError: `${('enter_currency')}`});
            } else {
                let obj = {
                    type: 1,
                    usrId: props.match.params.id,
                    companyDetails: {
                        currency: userInput.currency,
                    }
                };
                setShow({loadData: true});
                let accessToken = sessionStorage.getItem('accessToken');


                userProfileUpdate(obj, accessToken).then((res) => {
                    // ResponseFilter(res);
                    console.log(res, "sssssssssss")
                    setShow({loadData: false});
                    if (res.status == 1) {
                        setShow({
                            // ToastMessageSuccess: res.data.,
                            currencyBox: !show.currencyBox,
                        });
                        setNotification(true);


                        getMyUser();
                    }
                });
            }

        } else if (e == 2) {


            console.log("ssssssssssssSDDDDDDDDDDDDD", userInput.userCompanyName)
            if (!userInput.userCompanyName) {
                setUserInput({companyNameError: `${('Please enter company name')}`});
            } else {
                let obj = {
                    type: 2,
                    usrId: props.match.params.id,
                    companyDetails: {
                        companyName: userInput.userCompanyName,
                    }
                };
                setShow({loadData: true});
                let accessToken = sessionStorage.getItem('accessToken');


                userProfileUpdate(obj, accessToken).then((res) => {
                    // ResponseFilter(res);
                    console.log(res, "sssssssssss")

                    setShow({loadData: false});
                    if (res.status == 1) {
                        setShow({
                            companyNameError: '',

                            companyBox: !show.companyBox,
                        });
                        setNotification(true);


                        getMyUser();
                    } else {

                    }
                });
            }
        } else if (e == 3) { //email
            console.log(e, "PPP>>>ssss>>xxxxxxxxx", userInput.currency, "Dddddddddd")

            if (handleEmailValidation()) {

                console.log("xxxxxxxxxssssssssssssSDDDDDDDDDDDDD", e)
                // if (userInput.userCompanyName === ' ') {
                //     setUserInput({companyNameError: `${('enter_company_name')}`});
                // } else {
                let obj = {
                    type: 3,
                    usrId: props.match.params.id,
                    email: show.newEmail,
                    optifoPassword: show.optifoPasswod,
                    // additionalEmail: show.additionalEmail,
                };

                setShow({loadData: true});
                let accessToken = sessionStorage.getItem('accessToken');


                userProfileUpdate(obj, accessToken).then((res) => {
                    // ResponseFilter(res);
                    console.log(res, "sssssssssssasasasazvvvvvvv")

                    setShow({loadData: false});
                    if (res.status == 1) {
                        setShow({emailBox: false});
                        setNotification(true);

                        setShow({
                            optifoPasswodError: '',

                        });

                        getMyUser();
                    } else {
                        setShow({
                            optifoPasswodError: res.data,

                        });
                    }
                });
            }
        }
    };

    function handleValidation() {
        const zipRegx = /^[ A-Za-z0-9_./+-]{2,10}$/
        let validateZipRegx = zipRegx.test(String(userInput.postalCode));

        let validate = true;

        console.log(userInput, "Ssssssssssssssssssss1")
        if (userInput.streetAddress === '' || userInput.streetAddress === undefined) {
            validate = false;
            setUserInput({
                ...userInput,
                streetAddressError: `${('Enter street address')}`,
            });
        }
        console.log(userInput, "Ssssssssssssssssssss2")
        if (userInput.country === '') {
            validate = false;
            setUserInput({...userInput, countryError: `${('Enter country')}`});
        }


        if (userInput.currency === '' || userInput.currency === undefined) {
            validate = false;
            setUserInput({...userInput, currencyError: `${('enter_currency')}`});
        }
        console.log(userInput, "Ssssssssssssssssssss3")


        if (userInput.postalCode) {
            if (!validateZipRegx) {
                validate = false;
                setUserInput({
                    ...userInput,
                    postalCodeError: `${('Enter valid postal code')}`,
                });
            }
        }

        if (userInput.vatNumber) {
           if (userInput.vatNumber && userInput.vatNumber.length > 20) {
            validate = false;
            setUserInput({...userInput, vatNumberError: `${('Enter valid vat number')}`});
        }
        }
        console.log(userInput, "Ssssssssssssssssssss4")

        return validate;
    }

    const getMyBills = () => {
        let accessToken = sessionStorage.getItem('accessToken');
        let obj = `?usrId=${props.match.params.id}`
        getUserInvoices(obj, accessToken).then((res) => {
            // ResponseFilter(res);
            console.log(res, "sdddddddxxxxxxxxxxxxxxxxxxz")
            if (res.status == 1) {
                setBillingList(res.data);
            }
        });

        getUserChargesBill(obj, accessToken).then((res) => {

            console.log(res, "ASddddddddddddd", show, userInput, "zzzzzzzzzzz")
            if (res.status == 1) {
                console.log(res.data, "res.data.data", show, userInput, "zzzzzzzzzzz")

                let charges = res.data;
                if (charges.length > 0) {
                    // charges && charges.filter()
                }
                setChargesList(charges);
            }
        });

    };

    const ShowCurrencyNameBox = () => {
        setShow({
            currencyBox: !show.currencyBox,
            passwordBox: false,
            emailBox: false,
            companyNameBox: false,
            companyBox: false,

        });
        // getMyUser();
    };

    //end plan
    const getBrandImage = (img) => {
        // console.log(img,"imggggggggggggggggggg",<img src={"../../assets/img/images/visa.png"}/>)
        switch (img) {

            case 'Visa':
                setShow({brandImage: visaIcon});
                break;
            case 'MasterCard':
                setShow({brandImage: '../../assets/img/images/MasterCard.png'});
                break;

            case 'American Express':
                setShow({brandImage: '../../assets/img/images/American.jpg'});
                break;
            default:
                setShow({brandImage: '../../assets/img/images/default-card.png'});
                break;
        }
    };
    const getInvoiceTabValue = (e) => {
        setShow({

            defaultInvoiceTab: e,

        });
    };
    const getCreditTabValue = (e) => {
        setShow({

            defaultCreditTab: e,

        });
    };

    const showAdditional = (additional) => {
        console.log(additional, "Dddddd", additional.length)
        let jsx = [];
        additional.length && additional.map((val, i) => {

            jsx.push(<span id={"989i890"}>{val}{i < additional.length ? "," : ""} </span>)
        })
        return jsx;

    }
    const handleSelect = (e, type) => {
        e.preventDefault();
        setThresHoldStatus(thresHoldStatus == 1 ? 2 : 1)
        setShowActiveLogo(showActiveLogo == 1 ? 0 : 1)
        //2 for autofill 1 2 active inactive
        let accessToken = sessionStorage.getItem('accessToken');

        console.log(type, e.target.value, thresHoldStatus, "kjhgghjkl;")
        let params = {}
        if (type == 1) {

            params = {
                'usrId':props.match.params.id,
                'showActiveLogo': showActiveLogo == 1 ? 0 : 1,
            }

            // 'packId': creditPackId

            updateShowActiveLogo(params, accessToken).then((res) => {
                if (res.status == 1) {
                    getMyUser();

                }
            });
            // let accessToken = sessionStorage.getItem('accessToken');
            // setBackground(params, accessToken).then((res) => {
            //     // ResponseFilter(res);
            //     setShow({loadData: true});
            //     if (res.status == 1) {
            //         getBGImages();
            //     }
            // });

        } else {
            params = {
                'usrId':props.match.params.id,

                'type': 2,
                'thresholdRefill': thresHoldStatus == 1 ? 2 : 1,
            }


            updateThresholdCredit(params, accessToken).then((res) => {
                if (res.status == 1) {

                    getMyUser();

                }
            });
        }


    }
    const handleCouponRemove = () => {
        setShowCoupon(1);
        setShow({promo:''})
        let params = {

            'percentOff': 0,
            'couponId': '',
            "couponOff": 0,
            'usrId':props.match.params.id,
            'showCoupon': 1,

        }
        // }

        let accessToken = sessionStorage.getItem('accessToken');
        updateUserCoupon(params, accessToken).then((res) => {
            if (res.status == 1) {
                setShow({
                    codeMessage: "",
                    codeMessageInvalid: '',
                    percentOff: ''
                })
                getMyUser();

            }
        });

        // updateUserCoupon(params).then(res => {
        //     setEditType(false)
        //     setCurrentId('')
        //     setIsDisabled(false);
        //     if (res.status) {
        //         handleClose();
        //         getList();
        //     }
        // })
        // }

    }

    const printInvoice = (item) => {
        console.log("printInvoice printInvoice");
        let params = `?usrId=${props.match.params.id}&chargeId=${item.id}`;
        getInvoiceHistory(params).then((res) => {
            setCancelLoader(false);
            if (res.status == 1) {
               let url=res.data.filename
                window.open(url);
                setShow({ToastMessageSuccess: 'Downloaded succesfully'});
                setCancelLoader(false);
            }
        });
    };

    return (


        <div className="page_wrapper">
            <div className="row m-0">{console.log('lkjhgxxxxxxxxxx', show)}
                <div className="col-left">
                    <div className="px-lg-4 pt-3 pb-md-5 pb-4">
                        <h1 className="main-heading pb-md-3 mb-2">{('Account')}</h1>
                        <Tabs
                            defaultActiveKey="1"
                            activeKey={show.defaultTab}
                            onSelect={(e) => getTabValue(e)}
                            className="breadcrumb-account nav-sticky"
                        >
                            <Tab eventKey="1" title={('General')}>
                                <div className="account-tab">
                                    <div className="account-list">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className="">{('name')}</h5>
                                            <div>
                                                {show.userNameBox ? null : (
                                                    <span
                                                        className="c_pointer font-weight-bold"
                                                        onClick={ShowUserNameBox}
                                                    >
                            {show.userNameBox
                                ? `${'Cancel'}`
                                : `${('Edit')}`}
                          </span>
                                                )}
                                            </div>
                                        </div>
                                        {show.userNameBox ? null : (
                                            <p className="mb-0">
                                                {show.userName ? show.userName : ''}
                                            </p>
                                        )}
                                        {show.userNameBox && (
                                            <div className="email-ad-box mt-4">
                                                <div className="">
                                                    <div
                                                        className={`form-group md-custom-form ${
                                                            show.userNameError ? 'error' : ''
                                                        }`}
                                                    >
                                                        <input
                                                            label={('Full name')}
                                                            type="text"
                                                            maxLength={"35"}

                                                            className="form-control input-lg"
                                                            name="userName"
                                                            value={show.userName}
                                                            onChange={(e) => handelChange(e)}
                                                        />
                                                        {/*{show.userNameError ? (*/}
                                                        {/*   {show.userNameError}*/}
                                                        {/*) : (*/}
                                                        {/*    ''*/}
                                                        {/*)}*/}


                                                        {show.userNameError ? (
                                                            <InlineError errorMessage={show.userNameError}/>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                    <div className="btnwrapper">
                                                        <button
                                                            type="button"
                                                            className="btn btn-gray1 text-uppercase"
                                                            onClick={ShowUserNameBox}
                                                        >
                                                            {show.userNameBox
                                                                ? `${('Close')}`
                                                                : `${('Edit')}`}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={UpdateName}
                                                            className="btn btn-black text-uppercase"
                                                        >
                                                            {('update name')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="account-list">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className="">
                                                    {('email address')}
                                                </h5>
                                            </div>
                                            <div>
                                                {show.emailBox ? null : (
                                                    <span
                                                        className="c_pointer font-weight-bold"
                                                        onClick={ShowEmailBox}
                                                    >
                            {show.emailBox
                                ? `${('Close')}`
                                : `${('Edit')}`}
                          </span>
                                                )}
                                            </div>
                                        </div>
                                        <p className="mb-0 emailLow"> {show.userEmail}</p>
                                        {show.emailBox ? (
                                            <div className="email-ad-box mt-4">
                                                <div
                                                    className={`form-group md-custom-form ${
                                                        show.newEmailError ? 'error' : ''
                                                    }`}
                                                >
                                                    <input
                                                        label={('new email')}
                                                        type="email"
                                                        maxLength={"45"}
                                                        placeholder="New email"
                                                        className="form-control input-lg"
                                                        name="newEmail"
                                                        value={show.newEmail}
                                                        onChange={(e) => handelChange(e)}
                                                    />
                                                    {show.newEmailError ? (
                                                        <InlineError errorMessage={show.newEmailError}/>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div
                                                    className={`form-group md-custom-form ${
                                                        show.confrimEmailError ? 'error' : ''
                                                    }`}
                                                >
                                                    <input
                                                        label={('Confirm email')}
                                                        type="email"
                                                        maxLength={"45"}
                                                        placeholder="Confirm new email"
                                                        className="form-control input-lg"
                                                        name="confrimEmail"
                                                        value={show.confrimEmail}
                                                        onChange={(e) => handelChange(e)}
                                                    />
                                                    {show.confrimEmailError ? (
                                                        <InlineError
                                                            errorMessage={show.confrimEmailError}
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div
                                                    className={`form-group md-custom-form ${
                                                        show.optifoPasswodError ? 'error' : ''
                                                    }`}
                                                >
                                                    <input
                                                        label={('Optifo password')}
                                                        type="password"
                                                        maxLength={"35"}
                                                        placeholder="Password"
                                                        className="form-control input-lg"
                                                        name="optifoPasswod"
                                                        value={show.optifoPasswod}
                                                        onChange={(e) => handelChange(e)}
                                                    />
                                                    {show.optifoPasswodError ? (
                                                        <InlineError
                                                            errorMessage={show.optifoPasswodError}
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div className="btnwrapper">
                                                    <button
                                                        type="button"
                                                        className="btn btn-gray1 text-uppercase"
                                                        onClick={ShowEmailBox}
                                                    >
                                                        {show.emailBox
                                                            ? `${('close')}`
                                                            : `${('edit')}`}
                                                    </button>

                                                    <button
                                                        type="button"
                                                        onClick={(e) => UpdateCurrency(3)}
                                                        className="btn btn-black text-uppercase"
                                                    >
                                                        {('Edit')}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>

                                    <div className="account-list pb-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className="mb-0">
                                                {('Password')}
                                            </h5>
                                            <div>
                                                {show.passwordBox ? null : (
                                                    <span
                                                        className="c_pointer font-weight-bold"
                                                        onClick={ShowPasswordBox}
                                                    >{`${('Change password')}`}</span>
                                                )}
                                            </div>
                                        </div>
                                        {show.passwordBox ? (
                                            <div className="email-ad-box mt-4">
                                                <div
                                                    className={`input-w-icon form-group md-custom-form ${
                                                        show.oldPasswordError ? 'error' : ''
                                                    }`}
                                                >
                                                    <input
                                                        // label={('old password')}
                                                        placeholder="Old password"
                                                        maxLength={"45"}
                                                        type={show.showPassword2 ? 'password' : 'text'}
                                                        name="oldPassword"
                                                        value={show.oldPassword} className="form-control input-lg"
                                                        onChange={handelChange}
                                                    />
                                                    <span
                                                        className="rt-icon"
                                                        onClick={(e) =>
                                                            setShow({showPassword2: !show.showPassword2})
                                                        }
                                                    >
                            {show.showPassword2 ? (
                                <CloseEyeIcon/>
                            ) : (
                                <EyeIcon/>
                            )}
                          </span>
                                                    {show.oldPasswordError ? (
                                                        <InlineError errorMessage={show.oldPasswordError}/>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div
                                                    className={`input-w-icon form-group md-custom-form ${
                                                        show.newPasswordError ? 'error' : ''
                                                    }`}
                                                >
                                                    <input
                                                        label={('New password')}
                                                        placeholder="New password"
                                                        type={show.showPassword ? 'password' : 'text'}
                                                        name="newPassword"
                                                        maxLength={"45"}
                                                        value={show.newPassword}
                                                        className="form-control input-lg"
                                                        onChange={handelChange}
                                                    />
                                                    <span
                                                        className="rt-icon"
                                                        onClick={(e) =>
                                                            setShow({showPassword: !show.showPassword})
                                                        }
                                                    >
                            {show.showPassword ? <CloseEyeIcon/> : <EyeIcon/>}
                          </span>
                                                    {show.newPasswordError ? (
                                                        <InlineError errorMessage={show.newPasswordError}/>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div
                                                    className={`input-w-icon form-group md-custom-form ${
                                                        show.confirmPasswordError ? 'error' : ''
                                                    }`}
                                                >
                                                    <input
                                                        placeholder={('Confirm password')}
                                                        type={show.showPassword1 ? 'password' : 'text'}
                                                        name="confirmPassword"
                                                        maxLength={"45"}
                                                        value={show.confirmPassword}
                                                        className="form-control input-lg"
                                                        onChange={handelChange}
                                                    />
                                                    <span
                                                        className="rt-icon"
                                                        onClick={(e) =>
                                                            setShow({showPassword1: !show.showPassword1})
                                                        }
                                                    >
                            {show.showPassword1 ? (
                                <CloseEyeIcon/>
                            ) : (
                                <EyeIcon/>
                            )}
                          </span>
                                                    {show.confirmPasswordError ? (
                                                        <InlineError
                                                            errorMessage={show.confirmPasswordError}
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>

                                                <div className="btnwrapper">
                                                    <button
                                                        type="button"
                                                        className="btn btn-gray1 text-uppercase"
                                                        onClick={ShowPasswordBox}
                                                    >{`${('close')}`}</button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-black text-uppercase mt-3"
                                                        onClick={UpdatePassword}
                                                    >
                                                        {('update password')}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>

                                    <div className="account-list">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className="">
                                                {('company name')}
                                                {/*{show.companyBox }*/}
                                            </h5>
                                            <div>

                                                {show.companyBox ? (
                                                    <span
                                                        className="c_pointer font-weight-bold classUnderLine"
                                                        onClick={ShowCompany}
                                                    >{`${('Edit')}`}</span>
                                                ) : null}
                                            </div>
                                        </div>
                                        {show.companyBox ? (
                                            <div className="conpanyinfo_data">
                                                <p class="mb-0">{userInput.userCompanyName1}</p>
                                            </div>
                                        ) : (
                                            <div className="email-ad-box companyinfo">
                                                {/*<form onSubmit={(e)=>UpdateCurrency(2)}>*/}
                                                <div className="login-input pt-2">
                                                    <div
                                                        className={`form-group md-custom-form ${
                                                            userInput.companyNameError ? 'error' : ''
                                                        }`}
                                                    >
                                                        <label>
                                                            {('Enter company name')}
                                                        </label>
                                                        <MDBInput
                                                            type="text"
                                                            // maxLength={"45"}
                                                            className="form-control input-lg"
                                                            name="userCompanyName"
                                                            value={userInput.userCompanyName}
                                                            onChange={(e) =>
                                                                handleOnChange(e, 'userCompanyName')
                                                            }
                                                        />
                                                        {userInput.companyNameError ? (
                                                            <InlineError
                                                                errorMessage={userInput.companyNameError}
                                                            />
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </div>


                                                <div className="btnwrapper">
                                                    <button
                                                        type="button"
                                                        className="btn btn-gray1 text-uppercase"
                                                        onClick={closeCompany}
                                                    >{`${('close')}`}</button>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => UpdateCurrency(2)}
                                                        className="btn btn-black text-uppercase"
                                                    >
                                                        {('Edit')}
                                                    </button>
                                                </div>
                                                {/*</form>*/}
                                            </div>
                                        )}
                                    </div>


                                </div>
                                <div className="account-list border-top">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <h5 className="font-weight mb-0">
                                                {('Delete my Optifo account')}
                                            </h5>
                                        </div>
                                        <div>
                                            {updateSubscriptionId.length === 0 ||
                                            updateSubscriptionId === [] ||
                                            updateSubscriptionId.length <= 0 ? (
                                                <span
                                                    className="c_pointer font-weight-bold text-uppercase"
                                                    onClick={OpenDeleteAccountPopup}
                                                >
                          {('delete account')}
                        </span>
                                            ) : (
                                                <span
                                                    onClick={OpenCancelSubscriptionPopup}
                                                    className="c_pointer font-weight-bold text-uppercase"
                                                >
                          {('delete account')}
                        </span>
                                            )}
                                        </div>
                                    </div>
                                    <p className="mb-0"> {('If you delete your account, your images will be gone forever.')}</p>
                                </div>
                            </Tab>
                            <Tab eventKey="2" title={('Background & Logo')}>
                                <div className="account-tab">
                                    <p className="mb-0 mt-3">{('Select the background type you want to apply on all your exterior images.')}</p>
                                    {show.bgNLogo ? (
                                        <>
                                            <h5 className="mb-2 pt-3">
                                                {('Background')}
                                            </h5>

                                        </>
                                    ) : (
                                        ''
                                    )}
                                    {show.showCustomBg ? (
                                        ''
                                    ) : (
                                        <>
                                            <div className="pt-0 account-list">
                                                <div className="bg-tab-main">
                                                    <div className="mt-md-4 mt-3 bg-logo-wrapper">
                                                        <div className="custom-row">
                                                            {displayBg.map((items, i) => {
                                                                return (
                                                                    <div className="mob-100 mb-3" key={i}>
                                                                        <div className="account-card-list">
                                      <span
                                          className="delete-bg"
                                          onClick={() =>
                                              OpenBgDeleteModal(
                                                  items._id,
                                                  displayBg.length
                                              )
                                          }
                                      >
                                        <DeleteIcon/>
                                      </span>

                                                                            <div
                                                                                onClick={(e) => ActiveBg(e, items._id)}
                                                                            >
                                                                                <input
                                                                                    type="radio"
                                                                                    onChange={() => {
                                                                                        console.log();
                                                                                    }}
                                                                                    checked={items.isActive}
                                                                                    name="activeValue"
                                                                                    value={activeBG.activeValue}
                                                                                />
                                                                                <div className="select-bg">
                                                                                    <div>
                                                                                        <CheckIcon/>
                                                                                        <div
                                                                                            className="bg-lable text-uppercase">
                                                                                            {('Active')}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {items.backgroundImage ? (
                                                                                <div
                                                                                    className="h-100 d-flex align-items-center justify-content-center">
                                                                                    <img
                                                                                        src={items.backgroundImage}
                                                                                        className="mxw-100"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                            <img src={items.backgroundImage}
                                                                                 className="w-100"/>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                            {displayBg.length < 10 ? (
                                                                <div className="mob-100 mb-3">
                                                                    <CommonModal
                                                                        size="lg"
                                                                        openModal={OpenBgModal}
                                                                        show={show.modalBgDefault}
                                                                        heading={('Add a new custom background')}
                                                                        body={uploadBackgroundBody}
                                                                        modalName={addUploadFile}
                                                                        handleClose={CloseBgModal}
                                                                        footerDisplay="d-none"
                                                                        backdrop="static"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="account-list">
                                                {/* <h5 className="mb-4">
                                                    {('Logo')}
                                                </h5> */}
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex">
                                                        <h5 className="mb-4">
                                                        {('Logo')}
                                                        </h5>
                                                    </div>
                                                    <div className="text-right">

                                                        <label className="switch">
                                                            <input type="checkbox"
                                                                   checked={showActiveLogo == 1 ? true : false}
                                                                   onChange={(e) => handleSelect(e, 1)}/>
                                                            <span className="slider round"></span>
                                                        </label>

                                                    </div>
                                                </div>
                                                <div className="mt-md-4 mt-3 bg-logo-wrapper">
                                                    <div className="custom-row">
                                                        {displayLogo.map((items, i) => {
                                                            return (
                                                                <div className="mob-100 mb-3" key={i}>
                                                                    <div className="account-card-list">
                                    <span
                                        className="delete-bg"
                                        onClick={() =>
                                            OpenLogoDeleteModal(
                                                items._id,
                                                displayLogo.length
                                            )
                                        }
                                    >
                                      <DeleteIcon/>
                                    </span>
                                                                        <div
                                                                            onClick={(e) => ActiveLogo(e, items._id)}
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                onChange={() => {
                                                                                    console.log();
                                                                                }}
                                                                                checked={items.isActive}
                                                                                name="activeValueLogo"
                                                                                value={activeLogo.activeValueLogo}
                                                                            />

                                                                            <div className="select-bg">
                                                                                <div>
                                                                                    <CheckIcon/>
                                                                                    <div
                                                                                        className="bg-lable text-uppercase">
                                                                                        {('Active')}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {items.backgroundImage ? (
                                                                            <div
                                                                                className="h-100 d-flex align-items-center justify-content-center">
                                                                                <img
                                                                                    src={items.backgroundImage}
                                                                                    className="mxw-100"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}

                                                        {displayLogo.length < 10 ? (
                                                            <div className="mob-100 mb-3">
                                                                <CommonModal
                                                                    size="lg"
                                                                    openModal={OpenLogoModal}
                                                                    show={show.modalLogoDefault}
                                                                    heading={('Add a new custom logo')}
                                                                    body={uploadLogoBody}
                                                                    modalName={addUploadFile}
                                                                    handleClose={CloseLogoModal}
                                                                    footerDisplay="d-none"
                                                                    backdrop="static"
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {show.showWhiteBg ? (
                                        <div className="account-list">
                                            <h5 className="mb-4">
                                                {('Logo')}
                                            </h5>
                                            <div className="mt-md-4 mt-3 bg-logo-wrapper">
                                                <div className="custom-row">
                                                    {displayLogo.map((items, i) => {
                                                        return (
                                                            <div className="mob-100 mb-3" key={i}>
                                                                <div className="account-card-list">
                                  <span
                                      className="delete-bg"
                                      onClick={() =>
                                          OpenLogoDeleteModal(
                                              items._id,
                                              displayLogo.length
                                          )
                                      }
                                  >
                                    <DeleteIcon/>
                                  </span>

                                                                    <div onClick={(e) => ActiveBg(e, items._id)}>
                                                                        <input
                                                                            type="radio"
                                                                            onChange={() => {
                                                                                console.log();
                                                                            }}
                                                                            checked={items.isActive}
                                                                            name="activeValue"
                                                                            value={activeBG.activeValue}
                                                                        />
                                                                        <div className="select-bg">
                                                                            <div>
                                                                                <CheckIcon/>
                                                                                <div
                                                                                    className="bg-lable text-uppercase">
                                                                                    {('Active')}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {items.backgroundImage ? (
                                                                        <img
                                                                            src={items.backgroundImage}
                                                                            className="w-100"
                                                                        />
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}

                                                    {displayLogo.length < 10 ? (
                                                        <div className="mob-100 mb-3">
                                                            <CommonModal
                                                                size="lg"
                                                                openModal={OpenLogoModal}
                                                                show={show.modalLogoDefault}
                                                                heading={('Add a new custom logo')}
                                                                body={uploadLogoBody}
                                                                modalName={addUploadFile}
                                                                handleClose={CloseLogoModal}
                                                                footerDisplay="d-none"
                                                                backdrop="static"
                                                            />
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="7" title={('Banner & Number Plate')}>
                                <div className="account-tab">
                                    <p className="mb-0 mt-3">{('Select the banner and number plate you want to apply on your exterior images.')}</p>
                                    {show.bannerNPlate ? (
                                        <>
                                            <h5 className="mb-2 pt-3">
                                                {('Banner Image')}
                                            </h5>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                    <div className="pt-0 account-list">
                                        <div className="bg-tab-main">
                                            <div className="mt-md-4 mt-3 bg-logo-wrapper">
                                                <div className="custom-row">
                                                    {displayBanner.map((items, i) => {
                                                        return (
                                                            <div className="mob-100 mb-3" key={items._id || i}>
                                                                <div className="account-card-list">
                                                                    <span
                                                                        className="delete-bg"
                                                                        onClick={() =>
                                                                            OpenBannerDeleteModal(
                                                                                items._id,
                                                                                displayBanner.length
                                                                            )
                                                                        }
                                                                    >
                                                                        <DeleteIcon/>
                                                                    </span>
                                                                    <div
                                                                        onClick={(e) => ActiveBanner(e, items._id)}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            onChange={() => {}}
                                                                            checked={items.isActive}
                                                                            name="activeValueBanner"
                                                                            value={activeBanner.activeValueBanner}
                                                                        />
                                                                        <div className="select-bg">
                                                                            <div>
                                                                                <CheckIcon/>
                                                                                <div className="bg-lable text-uppercase">
                                                                                    {('Active')}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {items.backgroundImage ? (
                                                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                                                            <img
                                                                                src={items.backgroundImage}
                                                                                alt="banner"
                                                                                className="mxw-100"
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                    {displayBanner.length < 10 ? (
                                                        <div className="mob-100 mb-3">
                                                            <CommonModal
                                                                size="lg"
                                                                openModal={OpenBannerModal}
                                                                show={show.modalBannerDefault}
                                                                heading={('Add a new custom banner')}
                                                                body={uploadBannerBody}
                                                                modalName={addUploadFile}
                                                                handleClose={CloseBannerModal}
                                                                footerDisplay="d-none"
                                                                backdrop="static"
                                                            />
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="account-list">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex">
                                                <h5 className="mb-4">
                                                    {('Number Plate Image')}
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="mt-md-4 mt-3 bg-logo-wrapper">
                                            <div className="custom-row">
                                                {displayNumberPlate.map((items, i) => {
                                                    return (
                                                        <div className="mob-100 mb-3" key={items._id || i}>
                                                            <div className="account-card-list">
                                                                <span
                                                                    className="delete-bg"
                                                                    onClick={() =>
                                                                        OpenNumberPlateDeleteModal(
                                                                            items._id,
                                                                            displayNumberPlate.length
                                                                        )
                                                                    }
                                                                >
                                                                    <DeleteIcon/>
                                                                </span>
                                                                <div
                                                                    onClick={(e) => ActiveNumberPlate(e, items._id)}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        onChange={() => {}}
                                                                        checked={items.isActive}
                                                                        name="activeValueNumberPlate"
                                                                        value={activeNumberPlate.activeValueNumberPlate}
                                                                    />
                                                                    <div className="select-bg">
                                                                        <div>
                                                                            <CheckIcon/>
                                                                            <div className="bg-lable text-uppercase">
                                                                                {('Active')}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {items.backgroundImage ? (
                                                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                                                        <img
                                                                            src={items.backgroundImage}
                                                                            alt="number plate"
                                                                            className="mxw-100"
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                                {displayNumberPlate.length < 10 ? (
                                                    <div className="mob-100 mb-3">
                                                        <CommonModal
                                                            size="lg"
                                                            openModal={OpenNumberPlateModal}
                                                            show={show.modalNumberPlateDefault}
                                                            heading={('Add a new custom number plate')}
                                                            body={uploadNumberPlateBody}
                                                            modalName={addUploadFile}
                                                            handleClose={CloseNumberPlateModal}
                                                            footerDisplay="d-none"
                                                            backdrop="static"
                                                        />
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="3" title={'Credits'}>
                                <div className="account-tab">
                                    
                                    <div className="account-list border-bottom-0">
                                                    <>
                                                        <h5 className="mb-3"> Credit packs</h5>
                                                        <p className="mb-0">
                                                            Select the credit pack that gives your dealer the most
                                                            value. </p>
                                                    </>
                                    </div>

                                    <>
                                <div className="subscrition-plan mt-2">
                                        <div className="container">
                                            <div className="row justify-content-center">
                                               
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                <div className="pricing-box">
                                                    <h2>500 Credits</h2>
                                                        <p className="para2">€89 per transaction</p>
                                                                    <div className="mt-2">
                                                                        <button
                                                                            onClick={() => window.location.href = 'https://buy.stripe.com/28o02LamI3ye3Ha147'}
                                                                            className="mb-0 text-uppercase font-weight-bold btn btn-black"
                                                                        >
                                                                            {'subscribe'}
                                                                        </button>
                                                                    </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                <div className="pricing-box">
                                                    <h2>500 Credits</h2>
                                                        <p className="para2">DKK 695 per transaction</p>
                                                                    <div className="mt-2">
                                                                        <button
                                                                            onClick={() => window.location.href = 'https://buy.stripe.com/00gcPxbqM2ua5Pi7su?locale=da'}
                                                                            className="mb-0 text-uppercase font-weight-bold btn btn-black"
                                                                        >
                                                                            {'subscribe'}
                                                                        </button>
                                                                    </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                    <div className="pricing-box">
                                                        <h2>Unlimited Credits</h2>
                                                        <p className="para2">€129 per transaction</p>

                                                        <div className="mt-2">
                                                            <button
                                                                onClick={() => window.location.href = 'https://buy.stripe.com/fZecPxamI6Kq3Ha9AE'}
                                                                className="mb-0 text-uppercase font-weight-bold btn btn-black"
                                                            >
                                                                {'subscribe'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                    <div className="pricing-box">
                                                        <h2>Unlimited Credits</h2>
                                                        <p className="para2">DKK 995 per transaction</p>

                                                        <div className="mt-2">
                                                            <button
                                                                onClick={() => window.location.href = 'https://buy.stripe.com/9AQcPx7aw5Gm4LebIN?locale=da'}
                                                                className="mb-0 text-uppercase font-weight-bold btn btn-black"
                                                            >
                                                                {'subscribe'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>                                    
                                </div>

                                

                                
                            </>

                                </div>
                            </Tab>
                            <Tab eventKey="4" title={'Billing Information'}>
                                <div className="account-tab">
                                    {/*<div className="account-list">*/}
                                    {console.log(userInput, userInput.currency1, "billingListbillingList$$$", cardDetails, updateSubscriptionId)}
                                    {userInput.currency1 ?
                                        (
                                            <div className="account-list">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h5 className="">
                                                            {'Currency'}
                                                        </h5>


                                                    </div>
                                                    <div>
                                                        {chargesList.length > 0 ? "" : <span
                                                            className="c_pointer font-weight-bold classUnderLine "
                                                            onClick={ShowCurrencyNameBox}>{show.currencyBox ? '' : 'CHANGE'}</span>}
                                                        {/*)}*/}
                                                    </div>
                                                </div>
                                                <p className="mb-0">
                                                    {!show.currencyBox ? (userInput.currency ? (userInput.currency).toUpperCase() : '')

                                                        :
                                                        <div>
                                                            <p className="mb-0">
                                                                <div className="email-ad-box mt-4">
                                                                    {console.log(userInput, "billingListbillingList$$sssssssss$", cardDetails, updateSubscriptionId)}

                                                                    <div
                                                                        className={`form-group md-custom-form ${userInput.currencyError ? 'error' : ''}`}>

                                                                        {console.log(currencyData,"currencyDatacurrencyData")}
                                                                        <select className="form-control input-lg"
                                                                                name="currency"
                                                                                disabled={chargesList.length > 0 ? true : false}
                                                                            // value={(userInput.currency)?(userInput.currency.toUpperCase()):''}
                                                                                defaultValue={userInput.currency ? (userInput.currency) : ''}
                                                                                onChange={(e, val) => handleOnChange(e, 'currency', val)}>
                                                                           <option></option>
                                                                            {currencyData && currencyData.map((itm, i) => (
                                                                                <option
                                                                                    value={itm.currencyCode}>{itm.currencyName}</option>))}

                                                                            {/*    <>  <option>Select currency</option>
                                                                            <option value="USD">United States
                                                                                Dollars
                                                                            </option>
                                                                            <option value="EUR">Euro</option>
                                                                            <option value="GBP">United Kingdom
                                                                                Pounds
                                                                            </option>
                                                                            <option value="DZD">Algeria Dinars
                                                                            </option>
                                                                            <option value="ARP">Argentina
                                                                                Pesos
                                                                            </option>
                                                                            <option value="AUD">Australia
                                                                                Dollars
                                                                            </option>
                                                                            <option value="ATS">Austria
                                                                                Schillings
                                                                            </option>
                                                                            <option value="BSD">Bahamas
                                                                                Dollars
                                                                            </option>
                                                                            <option value="BBD">Barbados
                                                                                Dollars
                                                                            </option>
                                                                            <option value="BEF">Belgium Francs
                                                                            </option>
                                                                            <option value="BMD">Bermuda
                                                                                Dollars
                                                                            </option>
                                                                            <option value="BRR">Brazil Real
                                                                            </option>
                                                                            <option value="BGL">Bulgaria Lev
                                                                            </option>
                                                                            <option value="CAD">Canada Dollars
                                                                            </option>
                                                                            <option value="CLP">Chile Pesos
                                                                            </option>
                                                                            <option value="CNY">China Yuan
                                                                                Renmimbi
                                                                            </option>
                                                                            <option value="CYP">Cyprus Pounds
                                                                            </option>
                                                                            <option value="CSK">Czech Republic
                                                                                Koruna
                                                                            </option>
                                                                            <option value="DKK">Denmark Kroner
                                                                            </option>
                                                                            <option value="NLG">Dutch Guilders
                                                                            </option>
                                                                            <option value="XCD">Eastern
                                                                                Caribbean Dollars
                                                                            </option>
                                                                            <option value="EGP">Egypt Pounds
                                                                            </option>
                                                                            <option value="FJD">Fiji Dollars
                                                                            </option>
                                                                            <option value="FIM">Finland Markka
                                                                            </option>
                                                                            <option value="FRF">France Francs
                                                                            </option>
                                                                            <option value="DEM">Germany Deutsche
                                                                                Marks
                                                                            </option>
                                                                            <option value="XAU">Gold Ounces
                                                                            </option>
                                                                            <option value="GRD">Greece
                                                                                Drachmas
                                                                            </option>
                                                                            <option value="HKD">Hong Kong
                                                                                Dollars
                                                                            </option>
                                                                            <option value="HUF">Hungary Forint
                                                                            </option>
                                                                            <option value="ISK">Iceland Krona
                                                                            </option>
                                                                            <option value="INR">India Rupees
                                                                            </option>
                                                                            <option value="IDR">Indonesia
                                                                                Rupiah
                                                                            </option>
                                                                            <option value="IEP">Ireland Punt
                                                                            </option>
                                                                            <option value="ILS">Israel New
                                                                                Shekels
                                                                            </option>
                                                                            <option value="ITL">Italy Lira
                                                                            </option>
                                                                            <option value="JMD">Jamaica
                                                                                Dollars
                                                                            </option>
                                                                            <option value="JPY">Japan Yen
                                                                            </option>
                                                                            <option value="JOD">Jordan Dinar
                                                                            </option>
                                                                            <option value="KRW">Korea (South)
                                                                                Won
                                                                            </option>
                                                                            <option value="LBP">Lebanon Pounds
                                                                            </option>
                                                                            <option value="LUF">Luxembourg
                                                                                Francs
                                                                            </option>
                                                                            <option value="MYR">Malaysia
                                                                                Ringgit
                                                                            </option>
                                                                            <option value="MXP">Mexico Pesos
                                                                            </option>
                                                                            <option value="NLG">Netherlands
                                                                                Guilders
                                                                            </option>
                                                                            <option value="NZD">New Zealand
                                                                                Dollars
                                                                            </option>
                                                                            <option value="NOK">Norway Kroner
                                                                            </option>
                                                                            <option value="PKR">Pakistan
                                                                                Rupees
                                                                            </option>
                                                                            <option value="XPD">Palladium
                                                                                Ounces
                                                                            </option>
                                                                            <option value="PHP">Philippines
                                                                                Pesos
                                                                            </option>
                                                                            <option value="XPT">Platinum
                                                                                Ounces
                                                                            </option>
                                                                            <option value="PLZ">Poland Zloty
                                                                            </option>
                                                                            <option value="PTE">Portugal
                                                                                Escudo
                                                                            </option>
                                                                            <option value="ROL">Romania Leu
                                                                            </option>
                                                                            <option value="RUR">Russia Rubles
                                                                            </option>
                                                                            <option value="SAR">Saudi Arabia
                                                                                Riyal
                                                                            </option>
                                                                            <option value="XAG">Silver Ounces
                                                                            </option>
                                                                            <option value="SGD">Singapore
                                                                                Dollars
                                                                            </option>
                                                                            <option value="SKK">Slovakia
                                                                                Koruna
                                                                            </option>
                                                                            <option value="ZAR">South Africa
                                                                                Rand
                                                                            </option>
                                                                            <option value="KRW">South Korea
                                                                                Won
                                                                            </option>
                                                                            <option value="ESP">Spain Pesetas
                                                                            </option>
                                                                            <option value="XDR">Special Drawing
                                                                                Right (IMF)
                                                                            </option>
                                                                            <option value="SDD">Sudan Dinar
                                                                            </option>
                                                                            <option value="SEK">Sweden Krona
                                                                            </option>
                                                                            <option value="CHF">Switzerland
                                                                                Francs
                                                                            </option>
                                                                            <option value="TWD">Taiwan Dollars
                                                                            </option>
                                                                            <option value="THB">Thailand Baht
                                                                            </option>
                                                                            <option value="TTD">Trinidad and
                                                                                Tobago Dollars
                                                                            </option>
                                                                            <option value="TRL">Turkey Lira
                                                                            </option>
                                                                            <option value="VEB">Venezuela
                                                                                Bolivar
                                                                            </option>
                                                                            <option value="ZMK">Zambia Kwacha
                                                                            </option>
                                                                            <option value="EUR">Euro</option>
                                                                            <option value="XCD">Eastern
                                                                                Caribbean Dollars
                                                                            </option>
                                                                            <option value="XDR">Special Drawing
                                                                                Right (IMF)
                                                                            </option>
                                                                            <option value="XAG">Silver Ounces
                                                                            </option>
                                                                            <option value="XAU">Gold Ounces
                                                                            </option>
                                                                            <option value="XPD">Palladium
                                                                                Ounces
                                                                            </option>
                                                                            <option value="XPT">Platinum
                                                                                Ounces
                                                                            </option>
                                                                              </>
*/}
                                                                        </select>

                                                                        {userInput.currencyError ? (<InlineError
                                                                            errorMessage={userInput.currencyError}/>) : ('')}
                                                                    </div>
                                                                    <p className="currencyClass">Currency cannot be
                                                                        changed
                                                                        after first
                                                                        payment</p>

                                                                </div>


                                                            </p>
                                                            <div className="btnwrapper">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-gray1 text-uppercase"
                                                                    onClick={ShowCurrencyNameBox}
                                                                >
                                                                    {show.currencyBox
                                                                        ? `Close`
                                                                        : `Edit`}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    disabled={chargesList.length > 0 ? true : false}

                                                                    onClick={(e) => UpdateCurrency(1)}
                                                                    className="btn btn-black text-uppercase"
                                                                >
                                                                    {'Update'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }

                                                </p>
                                            </div>) : (
                                            <div className="account-list">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div><h5 className="mb-0">{'Currency'}</h5></div>

                                                </div>
                                                <div>
                                                    <p className="mb-0">
                                                        <div className="email-ad-box mt-4 ">
                                                            {console.log(userInput, "billingListbillingList$$sssssssss$", cardDetails, updateSubscriptionId)}

                                                            <div
                                                                className={`form-group md-custom-form classWidthCurrency${userInput.currencyError ? 'error' : ''}`}>


                                                                <select className="form-control input-lg"
                                                                        name="currency"
                                                                    // value={(userInput.currency)?(userInput.currency.toUpperCase()):''}

                                                                        disabled={chargesList.length > 0 ? true : false}
                                                                        defaultValue={(userInput.currency) ? (userInput.currency.toUpperCase()) : ''}
                                                                        onChange={(e) => handleOnChange(e, 'currency')}>
                                                                    <option></option>
                                                                    {currencyData && currencyData.map((itm, i) => (
                                                                        <option
                                                                            value={itm.currencyCode}>{itm.currencyName}</option>))}

                                                                </select>

                                                                {userInput.currencyError ? (<InlineError
                                                                    errorMessage={userInput.currencyError}/>) : ('')}
                                                            </div>
                                                            <p className="currencyClass">Currency cannot be changed
                                                                after
                                                                first payment</p>

                                                        </div>


                                                    </p>
                                                </div>
                                            </div>)}


                                    <div className="account-list ">
                                        {/*<h5 className="font-weight-bold mb-3">*/}
                                        {/*    {t('billing_contact')}*/}

                                        {/*</h5>*/}


                                        <div>


                                            <div className="account-list">


                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h5 className="mb-3">{'Billing contact'}</h5>
                                                    <div>
                                                        {show.companyNameBox ? null : (
                                                            <span
                                                                className="c_pointer font-weight-bold classUnderLine"
                                                                onClick={ShowCompanyName}
                                                            >{`${'Edit'}`}</span>
                                                        )}
                                                    </div>
                                                </div>

                                                {console.log(show.companyNameBox, "show.companyNameBoxMMMMMMM")}
                                                {show.companyNameBox ? null : (
                                                    <div className="conpanyinfo_data">

                                                        <p className="streetadress line-h-0 mt-2">

                                                            {show.userName}
                                                        </p>
                                                        <p className="streetadress2 ">

                                                            {show.userEmail}
                                                        </p>
                                                        <p className="streetadress2 ">

                                                            Additional
                                                            Email:{!_.isEmpty(show.additionalEmail1) ? showAdditional(show.additionalEmail1) : ''}

                                                        </p>
                                                        {/*<p>{userInput.userCompanyName1}</p>*/}

                                                        <p className="streetadress line-h-0 mt-2">
                                                            {userInput.streetAddress1}
                                                            {userInput.streetAddress1 ? ',' : ''} {''}
                                                            {userInput.suitUnit1 ? userInput.suitUnit1 : ''}
                                                        </p>
                                                        <p className="streetadress line-h-0 mt-2">
                                                            {(userInput.postalCode1 != 0 && userInput.postalCode1) ? userInput.postalCode1 : ''}
                                                            {(userInput.postalCode1) && userInput.city1 ? ',' : ''} {''}{userInput.city1}
                                                        </p>
                                                        <p className=" streetadress line-h-0 mt-2">
                                                            {(userInput.stateProvince1) ? userInput.stateProvince1 : ''}

                                                        </p>
                                                        <p className="streetadress2 ">
                                                            {userInput.country1}
                                                        </p>

                                                        {userInput.vatNumber1 ? (
                                                            <p>VAT
                                                                number: {userInput.vatNumber1 ? userInput.vatNumber1 : ''}</p>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                )}


                                                {show.companyNameBox && (
                                                    <div className="email-ad-box companyinfo">
                                                        <form onSubmit={UpdateCompanyName}>
                                                            <p className="mb-0">
                                                                <div className="login-input pt-2">
                                                                    <div
                                                                        className={`form-group md-custom-form ${userInput.fullNameError ? 'error' : ''}`}>
                                                                        <label>              {'Full name'}
                                                                        </label>
                                                                        <MDBInput
                                                                            type="text"
                                                                            maxLength={"35"}

                                                                            className="form-control input-lg"
                                                                            name="fullName"
                                                                            value={show.userName}
                                                                            onChange={(e) => handleOnChange(e, 'fullName')}
                                                                        />
                                                                        {userInput.fullNameError ? (
                                                                            <InlineError
                                                                                errorMessage={userInput.fullNameError}/>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </div>
                                                                </div>


                                                            </p>

                                                            <p className="mb-0">
                                                                <div className="login-input pt-2">
                                                                    <div
                                                                        className={`form-group md-custom-form ${userInput.emailError ? 'error' : ''}`}>
                                                                        <label>Email</label>
                                                                        <MDBInput
                                                                            placeHolder={"Email"}
                                                                            type="text"
                                                                            maxLength={"45"}

                                                                            className="form-control input-lg"
                                                                            name="email"
                                                                            value={show.userEmail}
                                                                            onChange={(e) => handleOnChange(e, 'email')}
                                                                        />
                                                                        {userInput.emailError ? (
                                                                            <InlineError
                                                                                errorMessage={userInput.emailError}/>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </div>
                                                                </div>


                                                            </p>
                                                            <p className="mb-0">
                                                                <div className="login-input pt-2">
                                                                    <div
                                                                        className={`form-group md-custom-form ${userInput.additionalEmailError ? 'error' : ''}`}>
                                                                        <label>Additional email</label>
                                                                        <MDBInput
                                                                            placeHolder={'Additional email'}
                                                                            type="text"
                                                                            className="form-control input-lg"
                                                                            name="additionalEmail"
                                                                            value={userInput.additionalEmail}
                                                                            onChange={(e) => handleOnChange(e, 'additionalEmail')}
                                                                        />
                                                                        {userInput.additionalEmailError ? (
                                                                            <InlineError
                                                                                errorMessage={userInput.additionalEmailError}/>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </div>
                                                                    <p className="currencyClass">seperate multiple email
                                                                        addresses by comma</p>
                                                                    <br/>

                                                                </div>


                                                            </p>

                                                            <div className={`form-group md-custom-form ${
                                                                userInput.countryError ? 'error' : ''
                                                            }`}>
                                                                <label>Country</label>

                                                                {whiteListedCountries.length ? <CountryDropdown

                                                                    placeholder="Country"
                                                                    value={userInput.country}
                                                                    name="country"
                                                                    whitelist={whiteListedCountries.length ? whiteListedCountries : ''}

                                                                    onChange={(val) => countrySelect(val)}
                                                                    className="form-control input-lg"
                                                                /> : ''}
                                                                {userInput.countryError ? (
                                                                    <InlineError
                                                                        errorMessage={userInput.countryError}
                                                                    />
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>


                                                            <div
                                                                className={`form-group md-custom-form ${
                                                                    userInput.streetAddressError ? 'error' : ''
                                                                }`}
                                                            >
                                                                <label>Street address</label>
                                                                <MDBInput
                                                                    placeHolder={'Street address'}
                                                                    type="text"
                                                                    maxLength={"35"}

                                                                    className="form-control input-lg"
                                                                    name="streetAddress"
                                                                    value={userInput.streetAddress}
                                                                    onChange={(e) =>
                                                                        handleOnChange(e, 'streetAddress')
                                                                    }
                                                                />
                                                                {userInput.streetAddressError ? (
                                                                    <InlineError
                                                                        errorMessage={userInput.streetAddressError}
                                                                    />
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>
                                                            {/*<div className="form-group">*/}
                                                            {/*<div className="col">*/}
                                                            {/*    <div className={`col md-custom-form ${userInput.suitUnitError ? 'error' : ''}`}>*/}
                                                            <div
                                                                className={`form-group md-custom-form ${userInput.suitUnitError ? 'error' : ''}`}>
                                                                <label>Apt/Suite</label>
                                                                <MDBInput
                                                                    placeHolder={'Apt/Suite '}
                                                                    type="text"
                                                                    maxLength={"35"}

                                                                    className="form-control input-lg"
                                                                    name="suitUnit"
                                                                    value={userInput.suitUnit}
                                                                    onChange={(e) =>
                                                                        handleOnChange(e, 'suitUnit')
                                                                    }
                                                                />
                                                                {userInput.suitUnitError ? (
                                                                    <InlineError
                                                                        errorMessage={userInput.suitUnitError}
                                                                    />
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>
                                                            {console.log(whiteListedCountries, "xzzzzzzzzzzzzzzzzzz")}

                                                            {singleAddress.showState == 1 ? <>
                                                                <label>State/Province</label>
                                                                <div
                                                                    className={`form-group md-custom-form ${userInput.stateProvinceError ? 'error' : ''}`}>
                                                                    <RegionDropdown
                                                                        country={userInput.country}
                                                                        value={userInput.stateProvince}
                                                                        onChange={(val) => stateSelect(val)}
                                                                        defaultOptionLabel={singleAddress.stateName ? singleAddress.stateName : 'State/Province'}
                                                                        showDefaultOption={singleAddress.stateName ? singleAddress.stateName : 'State/Province'}
                                                                        blankOptionLabel={singleAddress.stateName ? singleAddress.stateName : 'State/Province'}

                                                                        className="form-control input-lg state_province"
                                                                    />
                                                                    {userInput.stateProvinceError ? (
                                                                        <InlineError
                                                                            errorMessage={userInput.stateProvinceError}
                                                                        />
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div>
                                                            </> : ''}

                                                            <div className="form-group">
                                                                <div className="row">
                                                                    {singleAddress.showCity == 1 ? <div
                                                                        className={`col-8 md-custom-form ${
                                                                            userInput.cityError ? 'error' : ''
                                                                        }`}
                                                                    ><label>City</label>
                                                                        <MDBInput
                                                                            placeHolder={singleAddress.cityName ? singleAddress.cityName : ('City')}

                                                                            // placeHolder={'City'}
                                                                            type="text"
                                                                            maxLength={"35"}

                                                                            className="form-control input-lg"
                                                                            name="city"
                                                                            value={userInput.city}
                                                                            onChange={(e) => handleOnChange(e, 'city')}
                                                                        />
                                                                        {userInput.cityError ? (
                                                                            <InlineError
                                                                                errorMessage={userInput.cityError}
                                                                            />
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </div> : ''}
                                                                    {singleAddress && singleAddress.showPostal == 1 ?

                                                                        <div
                                                                            className={`col-4 md-custom-form ${
                                                                                userInput.postalCodeError ? 'error' : ''
                                                                            }`}
                                                                        ><label>Postal code</label>
                                                                            <MDBInput
                                                                                placeHolder={singleAddress.postalName ? singleAddress.postalName : ('Postal code')}

                                                                                type="text"
                                                                                // maxLength={""}

                                                                                className="form-control input-lg"
                                                                                name="postalCode"
                                                                                value={userInput.postalCode}
                                                                                onChange={(e) => handleOnChangeNum(e)}
                                                                            />
                                                                            {userInput.postalCodeError ? (
                                                                                <InlineError
                                                                                    errorMessage={userInput.postalCodeError}
                                                                                />
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                        </div> : ""}
                                                                </div>
                                                            </div>
                                                            {singleAddress && singleAddress.showVat == 1 ?

                                                                <div
                                                                    className={`form-group md-custom-form ${
                                                                        userInput.vatNumberError ? 'error' : ''
                                                                    }`}
                                                                ><label>Vat number</label>
                                                                    <MDBInput
                                                                        placeHolder={('Vat number')}
                                                                        type="number"
                                                                        maxLength={"8"}

                                                                        className="form-control classWidthPostal"
                                                                        name="vatNumber"
                                                                        value={userInput.vatNumber}
                                                                        onChange={(e) => handleOnChangeNum1(e)}
                                                                    />
                                                                    {userInput.vatNumberError ? (
                                                                        <InlineError
                                                                            errorMessage={userInput.vatNumberError}
                                                                        />
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div> : ""}
                                                            <div className="btnwrapper">
                                                                {/*<button*/}
                                                                {/*    type="button"*/}
                                                                {/*    className="btn btn-gray1 text-uppercase"*/}
                                                                {/*    onClick={ShowCompanyName}*/}
                                                                {/*>{`${t('close_text')}`}</button>*/}


                                                                {show.companyCancelBox ? <button
                                                                    type="button"
                                                                    className="btn btn-gray1 text-uppercase"
                                                                    onClick={ShowCompanyName}
                                                                >
                                                                    {'Cancel'}

                                                                </button> : ''}
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-black text-uppercase"
                                                                >
                                                                    {'update company info'}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="account-list ">
                                        <div className="d-flex justify-content-between">
                                            <h5 className="mb-2">
                                                {'Payment method'}
                                            </h5>


                                            {cardDetails ? (
                                                <div>
                                                    <span
                                                        onClick={OpenBillingModal}
                                                        className="c_pointer font-weight-bold classUnderLine "
                                                    >
                                                        {'Update'}
                                                    </span>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </div>


                                        <div className="email-ad-box companyinfo">

                                            <div>

                                                {console.log("-jjjjjjjjjjjjjjj------------>>", cardDetails, billingList)}
                                                {
                                                    !_.isEmpty(cardDetails) ? (
                                                            <>

                                                                <div className="mb-md-3 mb-2 ">
                                                                    <label className="custom-radio">
                                                                        <input
                                                                            type="radio"
                                                                            name="language"
                                                                            // checked={selectedLangage == 'en' ? true : false}
                                                                            // onChange={(e) => changeLanguage('en')}
                                                                        />

                                                                    </label>
                                                                </div>
                                                                <div className="d-flex visa-card align-items-center mb-3">
                                                                    {console.log(show.brandImage, "dsddddddddddddddddddddddd")}
                                                                    <img src={show.brandImage} alt="Visa"/>
                                                                    <span className="pl-3">•••• •••• •••• </span>
                                                                    <span className="pl-2">{cardDetails.last4}</span>
                                                                </div>

                                                                <div>
                                                                    {/*//update here*/}

                                                                    {show.modalBilling ? <>zxzx
                                                                        <div className="form-group">

                                                                            <div
                                                                                className={`form-group md-custom-form classWidthPayment${userInput.fullNameError ? 'error' : ''}`}>
                                                                                <label>Full name</label>
                                                                                {/*<MDBInput*/}
                                                                                {/*    // label={('')}*/}
                                                                                {/*    type="text"*/}
                                                                                {/*    maxLength={"35"}*/}

                                                                                {/*    className="form-control input-lg"*/}
                                                                                {/*    name="fullName"*/}
                                                                                {/*    value={show.userName}*/}
                                                                                {/*    onChange={(e) => handleOnChange(e, 'firstName')}*/}
                                                                                {/*/>*/}

                                                                                <MDBInput
                                                                                    // label={t('full_name')}
                                                                                    type="text"
                                                                                    className="form-control input-lg"
                                                                                    name="fullName"
                                                                                    maxLength={"35"}

                                                                                    value={show.userName}
                                                                                    onChange={(e) => handleOnChange(e, 'fullName')}
                                                                                />
                                                                                {userInput.fullNameError ? (
                                                                                    <InlineError
                                                                                        errorMessage={userInput.fullNameError}/>
                                                                                ) : (
                                                                                    ''
                                                                                )}
                                                                            </div>
                                                                            <CardNumberElement
                                                                                label={'Credit card number'}
                                                                                type="text"
                                                                                maxLength={"18"}

                                                                                className="form-control input-lg"
                                                                                name="creditNumberBilling"
                                                                                value={show.creditNumberBilling}
                                                                                onChange={updateBillingInfo}
                                                                            />
                                                                        </div>
                                                                        <div className="row custom-row">
                                                                            <div className="col-sm-8">
                                                                                <div className="form-group">
                                                                                    <CardExpiryElement
                                                                                        label={('Expiration date')}
                                                                                        type="text"
                                                                                        maxLength={"8"}

                                                                                        className="form-control input-lg"
                                                                                        name="expiryDateBilling"
                                                                                        value={show.expiryDateBilling}
                                                                                        onChange={updateBillingInfo}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-4">
                                                                                <div className="form-group">
                                                                                    <CardCVCElement
                                                                                        label={('Security code')}
                                                                                        type="text"
                                                                                        maxLength={"8"}

                                                                                        className="form-control input-lg"
                                                                                        name="securityCode"
                                                                                        value={show.securityCode}
                                                                                        onChange={updateBillingInfo}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <small
                                                                            className="text-red pl-2 mt-2">{show.errorMessage}</small>

                                                                        <div className="btnwrapper">
                                                                            <button type="button" variant="primary"
                                                                                    className={`btn btn-gray1 text-uppercase `}
                                                                                    onClick={CloseBillingModal}>{('Cancel')}</button>
                                                                            <button type="button" variant="primary"
                                                                                    className={`btn btn-black text-uppercas `}
                                                                                    onClick={updateCard}>{('Confirm')}</button>
                                                                        </div>
                                                                    </> : ''}
                                                                </div>

                                                                {updateSubscriptionId[0] ? (
                                                                    <p>
                                                                        {('Next billing date is')}{' '}
                                                                        {updateSubscriptionId[0].current_period_end
                                                                            ? moment(
                                                                                dateCoverter(
                                                                                    updateSubscriptionId[0]
                                                                                        .current_period_end
                                                                                ),
                                                                                'DD/MM/YYYY'
                                                                            ).format('MMMM DD, YYYY.')
                                                                            : ''}
                                                                    </p>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </>
                                                        ) :
                                                        (
                                                            <>
                                                                {/*<h5 className="font-weight-bold mb-2">*/}
                                                                {/*    {t('payment_mode')}*/}
                                                                {/*</h5>*/}
                                                                <Form onSubmit={UpdateSubscribeModal}>
                                                                    <div className="cm_striped_label mb-3">
                                                                        <div
                                                                            className={`form-group md-custom-form classWidthPayment${userInput.fullNameError ? 'error' : ''}`}>
                                                                            <label>Full name</label>
                                                                            {/*<MDBInput*/}
                                                                            {/*    // label={('')}*/}
                                                                            {/*    type="text"*/}
                                                                            {/*    maxLength={"35"}*/}

                                                                            {/*    className="form-control input-lg"*/}
                                                                            {/*    name="fullName"*/}
                                                                            {/*    value={show.userName}*/}
                                                                            {/*    onChange={(e) => handleOnChange(e, 'firstName')}*/}
                                                                            {/*/>*/}

                                                                            <MDBInput
                                                                                // label={t('full_name')}
                                                                                type="text"
                                                                                className="form-control input-lg"
                                                                                name="fullName"
                                                                                maxLength={"35"}

                                                                                value={show.userName}
                                                                                onChange={(e) => handleOnChange(e, 'fullName')}
                                                                            />
                                                                            {userInput.fullNameError ? (
                                                                                <InlineError
                                                                                    errorMessage={userInput.fullNameError}/>
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                        </div>

                                                                        <label
                                                                            className="form-control mb-3 classWidthPayment">
                                                                            Card number
                                                                            <CardNumberElement {...createOptions()}
                                                                                               onChange={handleChange}/>
                                                                        </label>

                                                                        <label
                                                                            className="form-control mb-3 classWidthPayment"
                                                                            htmlFor="Expiration">
                                                                            Expiration date
                                                                            <CardExpiryElement {...createOptions()}
                                                                                               onChange={handleChange}/>
                                                                        </label>
                                                                        <label
                                                                            className="form-control mb-3 classWidthPayment">
                                                                            Security code (CVC)
                                                                            <CardCVCElement
                                                                                {...createOptions()}
                                                                                className=""
                                                                                onChange={handleChange}
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                    {console.log(show.errorMessage, "errorMessageerrorMessageerrorMessage")}
                                                                    <small
                                                                        className="text-red pl-2 mt-2">{show.errorMessage}</small>
                                                                    {/* <MDBInput label={t('credit_car_number')} type="text" className="form-control input-lg" name="creditNumber" value={show.creditNumber} onChange={confirmAndPay}/> */}
                                                                    {/*</div>*/}
                                                                </Form>
                                                                {/*<button type="button" variant="primary"*/}
                                                                {/*        className={`btn btn-gray1 px-3 text-uppercase `}*/}
                                                                {/*        onClick={CloseSubscribeModal}>{"cancel"}</button>*/}
                                                                <button type="button" variant="primary"
                                                                        className={`btn btn-black px-3 text-uppercase `}
                                                                        onClick={UpdateSubscribeModal}>{"submit"}</button>


                                                                {/*                          <h5 className="font-weight-bold mb-2">*/}
                                                                {/*                              {t('payment_mode')}*/}
                                                                {/*                          </h5>*/}
                                                                {/*                          <p className="mb-0">*/}
                                                                {/*                              {t('select_plan')}*/}
                                                                {/*                              <span*/}
                                                                {/*                                  onClick={backToPlanTab}*/}
                                                                {/*                                  className="cursor-pointer text-black text-decoration-underline"*/}
                                                                {/*                              >*/}
                                                                {/*  {t('go_to_plan')}*/}
                                                                {/*</span>*/}
                                                                {/*                          </p>*/}


                                                            </>
                                                        )}
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="5" title={('Invoice history')}>
                                <div className="account-tab">

                                    <div className="account-list border-bottom-0">
                                        <h5 className="mb-3">
                                            {('Billing history')}{' '}
                                            <small className="text-gray2 font-weight-500">
                                                /
                                                {('Last 12 months')}
                                            </small>
                                        </h5>
                                        {/*<Tabs
                                            defaultActiveKey="1"
                                            activeKey={show.defaultInvoiceTab}
                                            onSelect={(e) => getInvoiceTabValue(e)}
                                            className="backgroundbox mb-3"
                                        >*/}

                                        {/*
                                            <Tab eventKey="1" title={"Subscription invoices"}>
                                                <table class="table table-custom">
                                                    <thead>
                                                    <tr>
                                                        <th>{('Date')}</th>
                                                        <th>{('Description')}</th>
                                                        <th>{('Period')}</th>
                                                        <th className="text-right">{('Subtotal')}</th>
                                                        <th className="text-right">{('Total')}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {!_.isEmpty(billingList) ? (
                                                        <>
                                                            {!billingList.length == 0
                                                                ? billingList.map((items, i) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>
                                                                                <Link href="#">
                                                                                    <a class="text-decoration-underline">
                                                                                        {dateCoverter(items.created)}
                                                                                    </a>
                                                                                </Link>
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    items.lines.data[0].plan.transform_usage ? items.lines.data[0].plan.transform_usage.divide_by &&items.lines.data[0].plan.transform_usage.divide_by : ''
                                                                                }{' '}
                                                                                {('Credits')}
                                                                            </td>

                                                                            <td>
                                                                                {items.lines.data[0].period.start
                                                                                    ? dateCoverter(
                                                                                        items.lines.data[0].period.start
                                                                                    )
                                                                                    : ''}{' '}
                                                                                -
                                                                                {items.lines.data[0].period.end
                                                                                    ? dateCoverter(
                                                                                        items.lines.data[0].period.end
                                                                                    )
                                                                                    : ''}
                                                                            </td>
                                          //                                   <td className="text-right">
                                          //                                       {console.log(items.lines.data[0].plan.amount / 100,"Sddddddddddddddddddddxxxxxxxxxxxxxc")}
                                                                                { items.lines.data[0].plan ?( items.lines.data[0].plan.amount?(items.lines.data[0].plan.amount / 100):0):''}{' '}{items.currency?(items.currency).toUpperCase():''}

                                                                                {items.lines && items.lines.data[0].plan.amount / 100}{' '}{items.currency ? (items.currency).toUpperCase() : ''}

                                                                                <br/>
                                                                                {items.lines.data[0].tax_amounts[0] && items.lines.data[0].tax_amounts[0].amount ? (
                                                                                    <span className="text-gray">
                                            (+
                                                                                        {items.lines.data[0].tax_amounts[0]
                                                                                            .amount / 100}{' '}
                                                                                        VAT)
                                          </span>
                                                                                ) : (
                                                                                    ''
                                                                                )}
                                                                            </td>

                                                                            <td className="text-right">
                                                                                {items.lines && items.lines.data[0].plan.amount / 100}{' '}{items.currency ? (items.currency).toUpperCase() : ''}
                                                                                <br/>
                                                                                {items.lines && items.lines.data[0] && items.lines.data[0].tax_amounts[0]&& items.lines.data[0].tax_amounts[0].amount ? (
                                                                                    <span className="text-gray">
                                            (+
                                                                                        {items.lines.data[0].tax_amounts[0].amount / 100}{' '}
                                                                                        VAT)
                                          </span>
                                                                                ) : (
                                                                                    ''
                                                                                )}
                                                                            </td>

                                                                            {items.lines.data[0].tax_amounts[0]
                                                                                .amount ? (
                                                                                <td className="text-right">
                                                                                    {items.lines.data[0].tax_amounts[0]
                                                                                        .amount /
                                                                                    100 +
                                                                                    items.lines.data[0].plan.amount /
                                                                                    100}{' '}
                                                                                    {items.currency?(items.currency).toUpperCase():''}
                                                                                </td>
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                            <td className="text-right">
                                                                                {
                                                                                    (items.lines &&items.lines.data[0] && items.lines.data[0].tax_amounts.length?
                                                                                        (items.lines.data[0].tax_amounts[0].amount  / 100):0) + (items.lines.data[0].plan.amount / 100)
                                                                                }{' '}
                                                                                {items.currency ? (items.currency).toUpperCase() : ''}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                                : ''}
                                                        </>
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5">
                                                                <div
                                                                    className="py-md-5 py-4 my-md-5 my-4 h-100 text-center col-md-12 no-data">
                                                                    <NoData/>
                                                                    <h6 className="text-gray mt-3">
                                                                        No data found
                                                                    </h6>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    </tbody>
                                                </table>
                                            </Tab>
*/}

                                        {/*<Tab eventKey="2" title={"Credit pack charges"}>*/}
                                        <table className="table table-custom">
                                            <thead>
                                            <tr>
                                                <th>{('Date')}</th>
                                                <th>{('Description')}</th>
                                                {/*<th>{('Download')}</th>*/}
                                                <th className="">{('Subtotal')}</th>
                                                {/*<th className="">{"Tax"}</th>*/}
                                                {/*<th className="">{"Coupon off"}</th>*/}

                                                <th className="">{('Total')}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {console.log(chargesList, "AaaaazzzzzzzzssssssssssssssssssssssLLL")}
                                            {!_.isEmpty(chargesList) ? (
                                                <>
                                                    {!chargesList.length == 0
                                                        ? chargesList.filter(items => items.invoice == null).map((items, i) => {
                                                            return (
                                                                <tr>{console.log(items, ">>>>>>>>>>>>>>>>>>L")}
                                                                    <td>
                                                                        <Link href="#">
                                                                            <a className="text-decoration-underline">
                                                                                {dateCoverter(items.created)}
                                                                            </a>
                                                                        </Link><p>
                                                                        <Link href="#">

                                                                            <a className="text-decoration-underline" target={"_blank"}
                                                                            //    href={items.receipt_url}
                                                                            //    download={items.receipt_url}
                                                                            onClick={()=>printInvoice(items)}
                                                                               >Download</a>
                                                                        </Link></p>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            items.metadata.credit ? items.metadata.credit : ''
                                                                        }{' '}
                                                                        {('Credits')}
                                                                    </td>


                                                                    {/*<td className="">*/}
                                                                    {/*    <a target={"_blank"}*/}
                                                                    {/*       href={items.receipt_url}*/}
                                                                    {/*       download={items.receipt_url}>Download</a>*/}
                                                                    {/*</td>*/}

                                                                    {items.metadata ? (
                                                                        <td className="">
                                                                            {Number(items.metadata.subTotal)-Number(items.metadata.couponOff)} {items.currency ? (items.currency).toUpperCase() : ''}
                                                                            <p>(+{items.metadata.tax ? (items.metadata.tax) : ''} {items.currency ? (items.currency).toUpperCase() : ''} VAT)</p>

                                                                            {/*{items.metadata.subTotal}{' '}{items.currency ? (items.currency).toUpperCase() : ''}*/}
                                                                        </td>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                    {/*{items.metadata.tax ? (*/}
                                                                    {/*    <td className="">*/}
                                                                    {/*        {(items.metadata.tax)}{' '}{items.currency ? (items.currency).toUpperCase() : ''}                                                                                </td>*/}
                                                                    {/*) : (*/}
                                                                    {/*    ''*/}
                                                                    {/*)}*/}
                                                                    {/*{items.metadata.couponOff ? (*/}
                                                                    {/*    <td className="">*/}
                                                                    {/*        {items.metadata.couponOff} {items.currency ? (items.currency).toUpperCase() : ''}*/}
                                                                    {/*    </td>*/}
                                                                    {/*) : (*/}
                                                                    {/*    ''*/}
                                                                    {/*)}*/}
                                                                    {items.amount ? (
                                                                        <td className="">
                                                                            {items.amount /
                                                                            100}{' '}{items.currency ? (items.currency).toUpperCase() : ''}
                                                                        </td>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </tr>
                                                            );
                                                        })
                                                        : ''}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td colSpan="5">
                                                        <div
                                                            className="py-md-5 py-4 my-md-5 my-4 h-100 text-center col-md-12 no-data">
                                                            <NoData/>
                                                            <h6 className="text-gray mt-3">
                                                                No data found
                                                            </h6>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                        {/*    </Tab>*/}
                                        {/*</Tabs>*/}
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="6" title={('Credit Balance')}>
                                <div className="account-tab">

                                    <div className="account-list">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h5 className="font-weight-bold">{('Credits left ')}-{' Plans '}</h5>
                                            <div>

                                            </div>
                                        </div>
                                        <p className="mb-0">
                                            <h5 className="credit mb-0">  {show.leftCredits}/
                                                <span className="creditFontCol">  {show.totalCredits}</span></h5>

                                        </p>

                                    </div>

                                    <div className="account-list">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h5 className="font-weight-bold mb-0">
                                                    Credits left - Packs
                                                </h5>
                                            </div>
                                            <div>
                                                {show.modalCredit ? null : (
                                                    <span
                                                        className="c_pointer font-weight-bold"
                                                        onClick={OpenCreditModal}
                                                    >
                            {show.modalCredit
                                ? `${('Close')}`
                                : `${('Add')}`}
                          </span>
                                                )}
                                            </div>
                                        </div>
                                        <p className="mb-0">
                                            <h5 className="credit mb-0">   {show.leftPackCredits ? show.leftPackCredits : 0}
                                            </h5>
                                        </p>

                                    </div>


                                    <div
                                        className="account-list">
                                        <>
                                            <h5 className="mb-2">

                                                {"Total"}
                                            </h5>
                                            <p className="row">

                                                <div className="AccountCreditPacks px-3">
                                                    <small> <span
                                                        className="headCredit"> Full credits </span></small>

                                                    <p className="fontCredit">{(show.totalCredits ? show.totalCredits : 0) + (show.totalPackCredits ? show.totalPackCredits : 0)}</p>

                                                </div>
                                                <div className="AccountCreditPacks px-3">
                                                    <small> <span
                                                        className="headCredit"> Preview credits</span></small>

                                                    <p className="fontCredit"> {(show.leftPackCredits ? show.leftPackCredits : 0) + (show.leftCredits ? show.leftCredits : 0)}</p>
                                                </div>

                                            </p>

                                        </>
                                    </div>

                                </div>
                            </Tab>


                        </Tabs>
                    </div>
                </div>
            </div>
            {show.cantDeleteBg ? (
                <CommonModal
                    show={show.modalBgDelete}
                    heading={('Delete Bg')}
                    body={('Can not delete last active background image.')}
                    btnFirst={('Cancel')}
                    submitModal={DeleteBg}
                    hideSubmitBtn="d-none"
                    handleClose={CloseBgDeleteModal}
                />
            ) : (
                <CommonModal
                    show={show.modalBgDelete}
                    heading={('Delete Bg Image')}
                    body={('Are you sure you want to delete this background image from Optifo?')}
                    btnFirst={('Cancel')}
                    btnSecond={('Delete')}
                    submitModal={DeleteBg}
                    handleClose={CloseBgDeleteModal}
                />
            )}

            {show.cantDeleteLogo ? (
                <CommonModal
                    show={show.modalLogoDelete}
                    heading={('Delete Logo?')}
                    body={('Can not delete last active logo image.')}
                    btnFirst={('Cancel')}
                    handleClose={CloseLogoDeleteModal}
                    submitModal={DeleteLogo}
                    hideSubmitBtn="d-none"
                />
            ) : (
                <CommonModal
                    show={show.modalLogoDelete}
                    heading={('Delete logo?')}
                    body={('Are you sure you want to delete this logo from Optifo? ')}
                    btnFirst={('Cancel')}
                    btnSecond={('Delete')}
                    handleClose={CloseLogoDeleteModal}
                    submitModal={DeleteLogo}
                />
            )}

            {show.cantDeleteBanner ? (
                <CommonModal
                    show={show.modalBannerDelete}
                    heading={('Delete Banner')}
                    body={('Can not delete last active banner image.')}
                    btnFirst={('Cancel')}
                    submitModal={DeleteBanner}
                    hideSubmitBtn="d-none"
                    handleClose={CloseBannerDeleteModal}
                />
            ) : (
                <CommonModal
                    show={show.modalBannerDelete}
                    heading={('Delete Banner Image')}
                    body={('Are you sure you want to delete this banner image from Optifo?')}
                    btnFirst={('Cancel')}
                    btnSecond={('Delete')}
                    submitModal={DeleteBanner}
                    handleClose={CloseBannerDeleteModal}
                />
            )}

            {show.cantDeleteNumberPlate ? (
                <CommonModal
                    show={show.modalNumberPlateDelete}
                    heading={('Delete Number Plate?')}
                    body={('Can not delete last active number plate image.')}
                    btnFirst={('Cancel')}
                    handleClose={CloseNumberPlateDeleteModal}
                    submitModal={DeleteNumberPlate}
                    hideSubmitBtn="d-none"
                />
            ) : (
                <CommonModal
                    show={show.modalNumberPlateDelete}
                    heading={('Delete number plate?')}
                    body={('Are you sure you want to delete this number plate from Optifo?')}
                    btnFirst={('Cancel')}
                    btnSecond={('Delete')}
                    handleClose={CloseNumberPlateDeleteModal}
                    submitModal={DeleteNumberPlate}
                />
            )}

            <ContentModal
                heading={('Change plan')}
                body={ChangePlanContent}
                show={show.modalChangePlan}
                firstBtn={('Confirm')}
                secondBtn={('Cancel')}
                handleClose={CloseChangeModal}
                submitModal={UpadtePlanModal}
                showPromoBox={showPromoBox}

            />

            <ContentModal
                show={show.modalCancelPlan}
                heading={('Are you sure, you want to cancel?')}
                body={CancelPlanContent}
                handleClose={CloseCancelModal}
                submitModal={cancelSubscription}
                firstBtn={('Yes')}
                secondBtn={('Go Back')}
            />


            <CommonModal
                className="custom-modal-sm"
                show={show.modalSubscribePlan}
                heading={('Confirm plan & pay')}
                body={SubscribePlanData}
                btnFirst={('Cancel')}
                btnSecond={('Confirm')}
                handleClose={CloseSubscribeModal}
                showPromoBox={showPromoBox}
                submitModal={createStripeSubscription}
                codeMessageInvalid={show.codeMessageInvalid}
            />


            <CommonModal
                className="custom-modal-sm"
                show={show.modalCreditPack}
                heading={('Confirm plan & pay')}
                adminPromo={show.adminPromo}
                body={SubscribePackData}
                btnFirst={('Cancel')}
                codeMessageInvalid={show.codeMessageInvalid}

                btnSecond={('BUY PACK')}
                handleClose={CloseSubscribeModal}
                showPromoBox={showPromoBox}
                submitModal={handleCheckout}

            />

            <CommonModal
                className="custom-modal-sm"
                show={show.modalCredit}
                heading={('Add credits')}
                body={CreditModalData}
                btnFirst={('Cancel')}
                btnSecond={('Add')}
                handleClose={CloseCreditModal}
                // showPromoBox={showPromoBox}
                submitModal={saveCreditPack}

            />

            {/*  {show.modalBilling ? (
                <CommonModal
                    className="custom-modal-sm"
                    // show={show.modalBilling}
                    heading={t('update_billing_info')}
                    body={upadteBillingInfo}
                    btnFirst={t('cancel_text')}
                    btnSecond={t('confirm_text')}
                    handleClose={CloseBillingModal}
                    submitModal={updateCard}
                />


                ) : (
                ''
            )}*/}

            <Modal
                show={popup.cancelSubscriptionPopup}
                centered
                onHide={CloseCancelSubscriptionPopup}
                className="custom-modal"
            >
                <Modal.Header>
                    <Modal.Title>{('Are you sure, you want to cancel?')}</Modal.Title>
                    <button
                        type="button"
                        className="close"
                        onClick={CloseCancelSubscriptionPopup}
                    >
                        <CloseIcon/>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p>{('In order to delete Optifo account, you’ll first need to cancel your Optifo plan. You have paid for your subscription until Month Date, Year and you will have access until then.')}</p>
                </Modal.Body>
                <Modal.Footer className="mt-md-4 mt-2">
                    <button
                        type="button"
                        variant="primary"
                        className="btn btn-black px-3 text-uppercase"
                        onClick={cancelSubscriptionDelete}
                    >
                        {('Yes, Cancel')}
                    </button>
                    <button
                        type="button"
                        variant="primary"
                        className="btn btn-gray1 px-3 text-uppercase"
                        onClick={CloseCancelSubscriptionPopup}
                    >
                        {('Go Back')}
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={popup.deleteAccountPopup}
                centered
                onHide={CloseCancelSubscriptionPopup}
                className="custom-modal"
            >
                <Modal.Header>
                    <Modal.Title>
                        {' '}
                        <p>{('Are you sure, you want to delete?')}</p>
                    </Modal.Title>
                    <button
                        type="button"
                        className="close"
                        onClick={CloseCancelSubscriptionPopup}
                    >
                        <CloseIcon/>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p>{('When you delete your Optifo account, all your images will be deleted and gone forever.')}</p>
                </Modal.Body>
                <Modal.Footer className="mt-md-4 mt-2">
                    <button
                        type="button"
                        variant="primary"
                        className="btn btn-black red-color px-3 text-uppercase"
                        onClick={deleteAccount}
                    >
                        {('Yes, Delete')}
                    </button>
                    <button
                        type="button"
                        variant="primary"
                        className="btn btn-gray1 px-3 text-uppercase"
                        onClick={CloseCancelSubscriptionPopup}
                    >
                        {('Go Back')}
                    </button>
                </Modal.Footer>
            </Modal>

        </div>)
}

const StripWrap = injectStripe(UserDetail);
{
}
export default function StripInput(props) {
    return (
        <StripeScriptLoader
            uniqueId="myUniqueId"
            script="https://js.stripe.com/v3/"
            loader="Loading..."
        >
            <StripeProvider
                apiKey={"pk_test_51Hx6PhAlAqEgWlowRdFWOCNzoW2K8KTazUTQFxIz6LA1ukhVvxdmEN0RepdpZTvMBgyWsD4HPPC4X9VKelzzu6Jn005TUgAMIM"}>
                <Elements>
                    <StripWrap {...props}/>
                </Elements>
            </StripeProvider>
        </StripeScriptLoader>
    );
}

// export default UserDetail;